// Declare global variables
let scene, camera, renderer, controls;
let textGroup, ornamentsGroup; // Groups for better management
let textMeshes = []; // Array to store text meshes
let ornamentMeshes = []; // Array to store ornament meshes
let bboxHelpers = []; // Array to store bounding box helpers
let loadedFonts = {}; // Cache for loaded fonts
let currentSelectedOrnament = null; // Variable to track the selected ornament
let isOrbiting = false; // Flag to track if the user is orbiting the camera
let isDragging = false; // Flag to track dragging
let justDragged = false; // Flag to track dragging of location handles
let isTransforming = false; // Flag to track text translation
let previousRenderedName = ''; // Track the last name that was rendered
let previousFontName = ''; // Track the last font that was rendered
let initialViewportHeight = window.innerHeight; // Initialize the initial viewport height
let characterOffsets = []; // Variable for storing the character offsets
let positionModified = false;
let selectedColor = null; // Store the selected color for when the text is created
let selectedOrnamentColor = null; // Store the selected color for when the text is created
let isFirstRender = true; // Tracks if this is the initial rendering
let userTextInputforFontList = '';
let orthoCamera; // Define an orthographic camera
let originalViewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight; // Store the initial viewport height
let selectedSize = null; // Variable to store the selected size
let uniqueColorCountGlobal; // Variable to track the amount of unique colors in the scene
let uniqueColorsGlobal; // Variable to store the list of colors in the scene
let currentInstructionIndex = 0; // Variable to track the current index of the orbit controls instructions.
let extraColors; //Calculate extra colors cost
let extraColorsCost; //
let ornamentCount;
let ornamentCost; // Example price for each ornament
let subtotal;

// Global variables for selected font
//let selectedFontName = 'Gentilis'; // Default font name
//let selectedFontFile = '{{ "gentilis_regular.typeface.json" | asset_url }}'; // Default font path (via Shopify's Liquid syntax)

let mouseDownPosition = new THREE.Vector2();
let mouseUpPosition = new THREE.Vector2();
const movementThreshold = 10; // pixels

// Create a helper sphere to show the click point in 3D space
const clickMarkerGeometry = new THREE.SphereGeometry(0.05, 32, 32); // Adjust size as needed
const clickMarkerMaterial = new THREE.MeshBasicMaterial({ color: 0xff0000 }); // Red sphere
const clickMarker = new THREE.Mesh(clickMarkerGeometry, clickMarkerMaterial);
clickMarker.visible = false; // Hide by default

// AWS S3 configuration
/*
const bucketName = "3dtext-objs"; // Replace with your bucket name
const region = "us-east-2"; // e.g., 'us-east-1'
const accessKeyId = "AKIAZI2LEKXWFBYC6DFP"; // Replace with your Access Key ID
const secretAccessKey = "XK5cTsCx+CuSL3WMcUbbVUePRd30zBsKzfgtgTzA"; // Replace with your Secret Access Key
*/

// Access the AWS config
const awsConfig = window.awsConfig;

const bucketName_var = awsConfig.bucketName;
const region_var = awsConfig.region;
const accessKeyId_var = awsConfig.accessKeyId;
const secretAccessKey_var = awsConfig.secretAccessKey;

AWS.config.update({
  region: region_var,
  accessKeyId: accessKeyId_var,
  secretAccessKey: secretAccessKey_var,
});

console.log("AWS Bucket:", bucketName_var);
console.log("AWS Region:", region_var);



// Initialize S3 with Transfer Acceleration enabled
const s3 = new AWS.S3({
  useAccelerateEndpoint: false,  // Enable transfer acceleration
});

let selectedGroup = null; // Select the clicked character and all subsequent characters
let currentCharacterIndex = 1; // Start with the second character

let animationFrameId; // Variable for animating the overlap update
let currentSpeed = 0; // Track the movement speed for the overlap update
let previousTimestamp = 0; // To calculate deltaTime

// List of sizes and their associated base prices
const availableSizes = [
  { size: '100mm', basePrice: 300 },
  { size: '150mm', basePrice: 350 },
  { size: '200mm', basePrice: 400 },
  { size: '280mm', basePrice: 500 }
];

// Define available ornaments
const availableOrnaments = [
  {
    name: 'Estrella',
    modelPath: 'https://cdn.shopify.com/3d/models/280df7fb13214b66/Estrella.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Estrella_81d2aec1-9e56-4bc8-995f-b4d162ffdc5f.png?v=1730272442',
    modifiableMaterial: true, // Allows modifying material
    initialColor: 'Yellow',
  },
  {
    name: 'Estrella 3D',
    modelPath: 'https://cdn.shopify.com/3d/models/0f10bf56cd9f0e98/Estrella_3D.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/estrella_3D.png?v=1730862381',
    modifiableMaterial: true, // Allows modifying material
    initialColor: 'Yellow',
  },
  {
    name: 'Luna',
    modelPath: 'https://cdn.shopify.com/3d/models/d2db1d89b91dab0f/Moon.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/moon.png?v=1730857593',
    modifiableMaterial: true, // Allows modifying material
    initialColor: 'Light Gray',
  },
  {
    name: 'Infinito',
    modelPath: 'https://cdn.shopify.com/3d/models/6d48398fb55a0ab4/Infninite.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Infinite.png?v=1730950476',
    modifiableMaterial: true, // Allows modifying material
    initialColor: 'Purple',
  },
  {
    name: 'Minnie',
    modelPath: 'https://cdn.shopify.com/3d/models/8e6551aaf84a670f/Minnie.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Minnie.png?v=1730271809',
    modifiableMaterial: true, // Allows modifying material
    initialColor: 'Magenta',
  },
  {
    name: 'Corazon 3D',
    modelPath: 'https://cdn.shopify.com/3d/models/e38dabc7c3cb698d/Heart_3D.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Heart_3D.png?v=1730351813',
    modifiableMaterial: true, // Does not allow modifying material
    initialColor: 'Red',
  },
  {
    name: 'Corazon silueta',
    modelPath: 'https://cdn.shopify.com/3d/models/a4a26cbc12511894/Heart_outline.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Heart_outline.png?v=1730352610',
    modifiableMaterial: true, // Does not allow modifying material
    initialColor: 'Sakura Pink Matte',
  },
  {
    name: 'Mariposa',
    modelPath: 'https://cdn.shopify.com/3d/models/9ca57fbd94ee391e/Butterfly.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Butterfly.png?v=1730353273',
    modifiableMaterial: true, // Does not allow modifying material
    initialColor: 'Purple',
  },
  {
    name: 'Trebol',
    modelPath: 'https://cdn.shopify.com/3d/models/c2586e5e4967fc0b/Clover.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Clover.png?v=1730354816',
    modifiableMaterial: true, // Does not allow modifying material
    initialColor: 'Mistletoe Green',
  },
  {
    name: 'Huella Canina',
    modelPath: 'https://cdn.shopify.com/3d/models/af02792d27a4d368/Dog_paw.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Dog_paw.png?v=1730356515',
    modifiableMaterial: true, // Does not allow modifying material
    initialColor: 'Blue',
  },
  {
    name: 'Corona Moderna',
    modelPath: 'https://cdn.shopify.com/3d/models/7e2ed71308dc097e/Modern_crown.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Modern_crown.png?v=1730262454',
    modifiableMaterial: true, // Does not allow modifying material
    initialColor: 'Silk Gold',
  },
  {
    name: 'Beso',
    modelPath: 'https://cdn.shopify.com/3d/models/6acb7157336f81c3/Kiss.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Kiss.png?v=1730267241',
    modifiableMaterial: true, // Does not allow modifying material
    initialColor: 'Red',
  },
  {
    name: 'Oso',
    modelPath: 'https://cdn.shopify.com/3d/models/00ecf10b08c7ae76/Bear.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Bear.png?v=1730182467',
    modifiableMaterial: true, // Does not allow modifying material
    initialColor: 'Black',
  },
  {
    name: 'Oso 3D',
    modelPath: 'https://cdn.shopify.com/3d/models/53718d0a4d8432dc/Bear_3D.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Bear_3D_5e4c4162-a1f1-4e20-b6f1-f337d56c50d8.png?v=1730358718',
    modifiableMaterial: true, // Does not allow modifying material
    initialColor: 'Silk Silver',
  },
  /*{
    name: 'Baby Shark',
    modelPath: 'https://cdn.shopify.com/3d/models/cd3c822108c376e0/baby_shark_pink.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/Babyshark_pink.png?v=1728953801',
    modifiableMaterial: false, // Does not allow modifying material
    initialColor: '',
  },*/
  /*{
    name: '49ers',
    modelPath: 'https://cdn.shopify.com/3d/models/2f7d1a9fab9f754e/49ers.glb',
    thumbnailPath: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/49ers.png?v=1728610939',
    modifiableMaterial: false, // Allows modifying material
    initialColor: '',
  },*/
  // Add more ornaments as needed
];

// Global list of available colors with their corresponding properties
const availableColors = [
  {
    name: 'Black',
    hexColor: '#1C1C1C',  //
    metallic: 0.2,        // Low metallic effect
    roughness: 0.5        // Rough appearance
  },
  {
    name: 'Jade White',
    hexColor: '#FFFFFF',  //
    metallic: 0.2,        // Low metallic effect
    roughness: 0.5        // Rough appearance
  },
  {
    name: 'Beige',
    hexColor: '#F7E6DE',  //
    metallic: 0.1,        // Low metallic effect
    roughness: 0.8        // Rough appearance
  },
  {
    name: 'Red',
    hexColor: '#C12E1F',  //
    metallic: 0.2,        // Low metallic effect
    roughness: 0.5        // Rough appearance
  },
  {
    name: 'Magenta',
    hexColor: '#EC008C',  //
    metallic: 0.2,        // Low metallic effect
    roughness: 0.5        // Rough appearance
  },
  {
    name: 'Orange',
    hexColor: '#FF6A13',  //
    metallic: 0.2,        // Low metallic effect
    roughness: 0.5        // Rough appearance
  },
  {
    name: 'Yellow',
    hexColor: '#F4EE2A',  //
    metallic: 0.2,        // Low metallic effect
    roughness: 0.5        // Rough appearance
  },
  {
    name: 'Bambu Green',
    hexColor: '#00AE42',  //
    metallic: 0.2,        // Low metallic effect
    roughness: 0.5        // Rough appearance
  },
  {
    name: 'Mistletoe Green',
    hexColor: '#3F8E43',  //
    metallic: 0.2,        // Low metallic effect
    roughness: 0.5        // Rough appearance
  },
  {
    name: 'Blue',
    hexColor: '#0A2989',  //
    metallic: 0.2,        // Low metallic effect
    roughness: 0.5        // Rough appearance
  },
  {
    name: 'Purple',
    hexColor: '#5E43B7',  //
    metallic: 0.2,        // Low metallic effect
    roughness: 0.5        // Rough appearance
  },
  {
    name: 'Light Gray',
    hexColor: '#D1D3D5',  //
    metallic: 0.1,        // Low metallic effect
    roughness: 0.7        // Rough appearance
  },
  {
    name: 'Dark Gray',
    hexColor: '#545454',  //
    metallic: 0.2,        // Low metallic effect
    roughness: 0.5        // Rough appearance
  },
  {
    name: 'Marine Blue Matte',
    hexColor: '#0078BF',  //
    metallic: 0,          // No metallic effect
    roughness: 1          // Matte finish
  },
  {
    name: 'Sakura Pink Matte',
    hexColor: '#E8AFCF',  //
    metallic: 0,          // No metallic effect
    roughness: 1          // Matte finish
  },
  {
    name: 'Dark Red Matte',
    hexColor: '#BB3D43',  //
    metallic: 0,          // No metallic effect
    roughness: 1          // Matte finish
  },
  {
    name: 'Dark Green Matte',
    hexColor: '#68724D',  //
    metallic: 0,          // No metallic effect
    roughness: 1          // Matte finish
  },
  {
    name: 'Dark Blue Matte',
    hexColor: '#042F56',  //
    metallic: 0,          // No metallic effect
    roughness: 1          // Matte finish
  },
  {
    name: 'Silk Silver',
    hexColor: '#EAECEB',  //
    metallic: 0.5,          // High metallic effect
    roughness: 0.1        // Smooth finish
  },
  {
    name: 'Silk Gold',
    hexColor: '#E5B03D',  // Gold color
    metallic: 0.5,          // High metallic effect
    roughness: 0.1        // Smooth finish
  }
  // Add more colors as needed
];

// Step-by-step instructions data
const instructions = [
  {
    gifUrl: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/zoom_sequence.gif?v=1729739838', // Zoom GIF
    text: 'Pincha con dos dedos para hacer zoom.',
    buttonText: 'Siguiente'
  },
  {
    gifUrl: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/pan_sequence.gif?v=1729739838', // Pan GIF
    text: 'Arrastra con dos dedos para moverte vertical y lateralmente.',
    buttonText: 'Siguiente'
  },
  {
    gifUrl: 'https://cdn.shopify.com/s/files/1/0623/8011/4141/files/orbit_sequence.gif?v=1729739838', // Orbit GIF
    text: 'Arrastra con un dedo para rotar el modelo.',
    buttonText: '¡Entendido!'
  }
];

// Define the minimum depth change percentage (e.g., 20%)
const MIN_DEPTH_CHANGE_PERCENTAGE = 20;

// Variable to keep track of the previous character's depth
let previousDepth = null;

// Global variable to store the currently selected ornament
let selectedOrnament = null;

// Load STLLoader
const loader = new THREE.STLLoader();

// Create TransformControls (will be initialized inside initScene)
let transformControls;

// Raycaster for detecting clicks
const raycaster = new THREE.Raycaster();
const mouse = new THREE.Vector2();

// Initial load adjustments
window.addEventListener('load', () => {
  originalViewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
  console.log('originalViewportHeight', originalViewportHeight);
  adjustSceneContainerSize();

  if (isAppleDevice && window.visualViewport) {
    // Add event listener to detect changes in the visual viewport for Apple devices
    window.visualViewport.addEventListener('resize', adjustSceneContainerSize);
  }
});

// Wait for the DOM to load
document.addEventListener('DOMContentLoaded', () => {
  initScene();

  // Get references to modal elements for the Text Input
  const textModal = document.getElementById('textModal');
  const userTextInput = document.getElementById('userTextInput');
  const submitTextButton = document.getElementById('submitTextButton');
  const changeTextButton = document.getElementById('changeTextButton');

  // Get references to modal elements for the Text Color selection
  const colorButton = document.getElementById('colorButton');
  const colorModal = document.getElementById('colorModal');
  const colorList = document.getElementById('colorList');
  const colorSelect = document.getElementById('colorButton');

  // Get references to modal elements for the Text Color selection
  const ornamentColorModal = document.getElementById('ornamentColorModal');
  
  // Get references to font modal elements
  const fontButton = document.getElementById('fontButton');
  const fontModal = document.getElementById('fontModal');
  const fontList = document.getElementById('fontList');


  // Make sure the Font Modal is hidden on page load
  hideFontModal();

  // Open the colors modal when the button is clicked
  colorButton.addEventListener('click', () => {
    populateColorList(); // Populate the color list each time the modal opens
    showColorModal();
  });

  // Populate the font list when the page loads
  //populateFontList();

  // Open the font modal when the "Fuente" button is clicked
  fontButton.addEventListener('click', () => {
    fontModal.style.display = 'flex';
  });

  // DEPRECATED: We will use the startGuidedFlow instead.
  // Show the modal when the customizer loads
  // window.addEventListener('load', showTextModal);

  // Call the guided flow on page load
  window.addEventListener('load', () => {
    if (isFirstRender) startGuidedFlow(); // Start the guided flow only if it's the first render
  });

  // Show the modal when "Cambiar Nombre" button is clicked
  changeTextButton.addEventListener('click', showTextModal);

  // Update the text when "Listo!" button is clicked
  submitTextButton.addEventListener('click', () => {
    populateFontList(userTextInput.value);
    update3DText();
  });

  
  window.addEventListener('click', (event) => {
    // Optional: Hide the text modal when clicking outside the content
    if (event.target === textModal) {
      if (isFirstRender) return;
      hideTextModal();
    }

    // Close the ornaments modal when clicking outside of the modal content
    const modal = document.getElementById('custom-ornamentsModal'); 
    if (event.target === modal) {
      closeOrnamentsModal();
    }

    // Close the font modal when clicking outside of it
    if (event.target === fontModal) {
      if (isFirstRender) return;
      fontModal.style.display = 'none';
    }

    // Close the colors modal when clicking outside of it
    if (event.target === colorModal) {
      if (isFirstRender) return;
      colorModal.style.display = 'none';
    }

    // Close the colors modal when clicking outside of it
    if (event.target === ornamentColorModal) {
      if (isFirstRender) return;
      ornamentColorModal.style.display = 'none';
    }
    
  });

  // Existing event listeners
  const renderButton = document.getElementById('renderButton');
  renderButton.addEventListener('click', () => {

    const bbox = new THREE.Box3().setFromObject(textGroup);
    const center = bbox.getCenter(new THREE.Vector3());
    
    render3DText();
    camera.position.set(-5, 4, 6);
    controls.target.set(center.x, 0, center.z);
    camera.updateProjectionMatrix(); // Ensure the projection matrix is updated
    controls.update(); // Update OrbitControls with the new target and position
  });

  /*
  const overlapSlider = document.getElementById('overlapSlider');
  overlapSlider.addEventListener('input', _.debounce(() => {
    // Update the overlap percentage display
    document.getElementById('overlapValue').textContent = overlapSlider.value;

    // Update the positions of existing text meshes based on new overlap
    updateOverlap();
  }, 100)); // Adjust delay as needed
  */

  // Initialize the scale slider functionality
  handleScaleChange();  

  // Handle "Add Ornament" button click
  document.getElementById('addOrnamentButton').addEventListener('click', addOrnamentToScene);

  // Handle bounding boxes toggle
  //const toggleBBoxes = document.getElementById('toggleBBoxes');
  //toggleBBoxes.addEventListener('change', () => {
  //  const isChecked = toggleBBoxes.checked;
  //  bboxHelpers.forEach((helper) => {
  //    helper.visible = isChecked;
  //  });
  //});

  // Handle "Export STL" button click
  document.getElementById('exportButton').addEventListener('click', exportOBJ);

  // Handle "Add to Cart" button click
  document.getElementById('addToCartButton').addEventListener('click', addToCart);

  // Event listeners for opening and closing the ornaments modal
  document.getElementById('ornamentsButton').addEventListener('click', function() {
    console.log('Ornaments button clicked');
    openOrnamentsModal();
  });
  //document.querySelector('.custom-close-button').addEventListener('click', closeOrnamentsModal);

  // Add the event listener for the scale slider
  document.getElementById('scaleSlider').addEventListener('input', function () {
    const scaleValue = parseFloat(this.value);
    document.getElementById('scaleValue').textContent = scaleValue.toFixed(1);

    if (currentSelectedOrnament) {
        console.log('currentSelectedOrnament:', currentSelectedOrnament)
        // Scale the selected ornament uniformly based on the slider input
        currentSelectedOrnament.scale.set(scaleValue, scaleValue, scaleValue);

        // Calculate min Y of the bounding box and apply scaling
        const ornamentMinY = currentSelectedOrnament.position.y+(currentSelectedOrnament.userData.baseScale*scaleValue*currentSelectedOrnament.children[0].geometry.boundingBox.min.y);

        // If the bottom of the ornament is below the text's bottom plane (Y = 0), move it up
        
        if (ornamentMinY < 0) {
          //console.log('Moving the object up due to:', [currentSelectedOrnament.position.y, currentSelectedOrnament.scale.y, currentSelectedOrnament.geometry.boundingBox.min.y])
          currentSelectedOrnament.position.y -= ornamentMinY;
          //console.log(`Ornament moved up by: ${-ornamentMinY}`);
          //console.log('New Scale:', currentSelectedOrnament.scale.y)
          //console.log('currentSelectedOrnament:', currentSelectedOrnament)
        }
    }

  });

  // DEPRECATED: Replacing the color dropdown for a color list embedded in a modal
  // Event listener for the ornament color dropdown
  /*
  document.getElementById('ornamentColorSelect').addEventListener('change', function () {
    const selectedOrnamentColor = this.value;
    console.log('Selected color:', selectedOrnamentColor)
    if (currentSelectedOrnament) {
      // Get the selected color properties (like metallic and roughness)
      const { color, metalness, roughness } = getSelectedColorProperties(selectedOrnamentColor);
      
      // Apply the color and material properties to the selected ornament
      currentSelectedOrnament.traverse((child) => {
        if (child.isMesh) {
          child.material.color.set(color);
          child.material.metalness = metalness;
          child.material.roughness = roughness;
          child.material.needsUpdate = true;
        }
      });
    }

    // Check the color limit when selecting a new color for an ornament
    checkColorLimit();
  });
  */

  // Event listener for deleting the currently selected ornament
  document.getElementById('deleteOrnamentButton').addEventListener('click', function () {
    if (currentSelectedOrnament) {
      // Remove the ornament from the scene and from the tracking array
      ornamentsGroup.remove(currentSelectedOrnament);

      // Remove the bounding box helper (if used)
      const bboxHelperIndex = bboxHelpers.findIndex(helper => helper.object === currentSelectedOrnament);
      if (bboxHelperIndex !== -1) {
        scene.remove(bboxHelpers[bboxHelperIndex]);
        bboxHelpers.splice(bboxHelperIndex, 1);
      }

      // Remove the ornament from the array
      const ornamentIndex = ornamentMeshes.indexOf(currentSelectedOrnament);
      if (ornamentIndex !== -1) {
        ornamentMeshes.splice(ornamentIndex, 1);
      }

      // Detach the TransformControls
      transformControls.detach();

      // Hide the ornament control popup
      toggleOrnamentPopup(false);

      // Clear the currently selected ornament
      currentSelectedOrnament = null;

      // Check the color limit when deleting an ornament
      checkColorLimit();

      console.log('Ornament deleted');
    }
  });

  // Add event listener to the color dropdown for real-time color updates
  /*
  document.getElementById('colorSelect').addEventListener('change', function () {
    const selectedHex = this.value;
    const selectedColor = availableColors.find(color => color.hexColor === selectedHex);

    if (selectedColor) {
      updateTextColor(selectedColor);  // Call the function to update text color if applicable
      
      // Check the color limit when selecting a new color for the text
      checkColorLimit();

    } else {
      console.error('Selected color not found in availableColors.');
    }
  });
  */
  

  // Add event listener for the Reset View button
  document.getElementById('resetViewButton').addEventListener('click', () => {
    updateCameraCenter();
  });

  // Ornaments related initializations
  populateOrnamentsGrid();

  // Add an event listener to detect when the user selects a new color
  //populateColorDropdown();
  document.getElementById('colorButton').addEventListener('change', getSelectedColorProperties);

  // Add an event listener to detec when the user wants to adjust the overlap
  document.getElementById('traslapeButton').addEventListener('click', () => {
    console.log('Traslape button clicked');
    startOverlapAdjustment(); // Launch overlap adjustment phase
  });

  // Adjust the size of the rendering area dynamically based on the header and UI section
  adjustSceneContainerSize();

  // Event Listener to detect when the developer clicks on the reset Scene Container button
  /*const resetSceneContainerButton = document.getElementById('resetSceneContainerButton');
  resetSceneContainerButton.addEventListener('click', () => {
    adjustSceneContainerSize();
    addCrosshairToScene();
  });*/

  // Event listener for "Ver instrucciones" link
    document.getElementById('showInstructionsLink').addEventListener('click', function () {
    // Open the instructions modal
    document.getElementById('overlapInstructionsModal').style.display = 'flex';
  
    // Close the instructions modal when 'Entendido' is clicked
    document.getElementById('overlapInstructionsOkButton').onclick = function () {
      document.getElementById('overlapInstructionsModal').style.display = 'none';
  
      // Resume the overlap adjustment from the current character
      if (currentCharacterIndex >= 1 ) {
      startOverlapAdjustment(currentCharacterIndex);  // Resume from current character
      }
    };
  });

  // Event listener for the Ornament Color button to open the modal
  document.getElementById('ornamentColorButton').addEventListener('click', function () {
    document.getElementById('ornamentColorModal').style.display = 'flex';
    populateOrnamentColorList(); // Populate the color list when modal opens
  });

  // Event listener to open the size modal
  populateSizeButtons(); // Populate the sizes list once on DOM content load.
  document.getElementById('sizeButton').addEventListener('click', () => {
    // Call the function to populate size buttons on page load or modal open
    document.getElementById('sizeModal').style.display = 'flex'; // Show modal
  });
  
});

// Initialize the Three.js scene, camera, renderer, and controls
function initScene() {
  // Create the scene
  scene = new THREE.Scene();
  scene.background = new THREE.Color(0xffffff); // White background

  // Set up the camera
  camera = new THREE.PerspectiveCamera(
    25, // Field of view
    window.innerWidth / window.innerHeight, // Aspect ratio
    0.1, // Near clipping plane
    1000 // Far clipping plane
  );
  camera.position.set(0, 0, 15); // Adjust as needed
  camera.lookAt(0, 0, 0); // Look at the center of the scene

  // Initialize the renderer
  renderer = new THREE.WebGLRenderer({ antialias: true });

  // Adjust the size of the rendering area dynamically based on the header and UI section
  adjustSceneContainerSize();
  
  renderer.setClearColor(0xffffff, 1); // White background
  renderer.shadowMap.enabled = true; // Enable shadows
  renderer.shadowMap.type = THREE.PCFSoftShadowMap; // Softer shadows

  // Add the renderer to the DOM
  const container = document.getElementById('scene-container');
  container.appendChild(renderer.domElement);

  // Set up OrbitControls for user interaction
  controls = new THREE.OrbitControls(camera, renderer.domElement);  
  controls.enableDamping = true; // Enable damping for smoother controls
  controls.enablePan = true; // Enable panning

  // Add ground plane and lighting
  addSceneElements();

  // Create groups for better management
  textGroup = new THREE.Group();
  ornamentsGroup = new THREE.Group();
  scene.add(textGroup, ornamentsGroup);

  // Initialize TransformControls after camera and renderer are set
  transformControls = new THREE.TransformControls(camera, renderer.domElement);
  transformControls.setMode('translate'); // Lock to translate mode
  transformControls.showZ = false; // Allow movement along Z-axis
  transformControls.showX = true;
  transformControls.showY = true;
  // Remove any mode switching capabilities
  // transformControls.setRotationSnap(null); // No rotation
  // transformControls.setScaleSnap(null); // No scaling

  // Add TransformControls to the scene
  scene.add(transformControls);

  // Start the animation loop
  animate();

  // Setup event listeners after initializing scene components
  setupEventListeners();
}

// Consolidated Event Listeners Function
function setupEventListeners() {
  // Add event listener to adjust the scene container size when the window is resized
  window.addEventListener('resize', adjustSceneContainerSize);
  window.addEventListener('orientationchange', adjustSceneContainerSize);

  /*
  window.addEventListener('focusout', () => {
    // On iOS, when the keyboard disappears, the page layout can remain pushed up
    setTimeout(() => {
      originalViewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      adjustSceneContainerSize();
    }, 100); // Delay ensures the keyboard is fully closed
  });
  */

  // Add event listeners for mouse interactions
  renderer.domElement.addEventListener('mousedown', onMouseDown, true);
  renderer.domElement.addEventListener('mousemove', onMouseMove, true);
  renderer.domElement.addEventListener('mouseup', onMouseUp, true);

  // Handle touch start (for mobile devices)
  // renderer.domElement.addEventListener('touchstart', onTouchStart, false);

  // Handle touch end (for mobile devices)
  // renderer.domElement.addEventListener('touchend', onTouchEnd, false);

  // Prevent OrbitControls from interfering with TransformControls
  transformControls.addEventListener('dragging-changed', function (event) {
    controls.enabled = !event.value;
    isDragging = event.value; // Update the dragging flag

    if (!event.value) {
      // Dragging has ended; set justDragged to true
      justDragged = true;
      console.log(`Translation drag ended. justDragged set to: ${justDragged}`);

      // Reset justDragged after a slight delay to ignore immediate click events
      setTimeout(() => {
        justDragged = false;
        console.log(`justDragged reset to: ${justDragged}`);
      }, 300); // Increased delay to 300 milliseconds
    }
  });

  // Enforce Z position during transformations to keep ornaments coplanar
  transformControls.addEventListener('objectChange', () => {
    if (currentSelectedOrnament) {
      console.log('Transform Controls ObjectChange event listener for Z Plane entered');
      // Reset Z position to the fixed value (Z = 0)
      //currentSelectedOrnament.position.z = currentSelectedOrnament.userData.fixedZ;
      // Calculate min Y of the bounding box and apply scaling
      const ornamentMinY = currentSelectedOrnament.position.y+(currentSelectedOrnament.scale.y*currentSelectedOrnament.children[0].geometry.boundingBox.min.y);

      // If the bottom of the ornament is below the text's bottom plane (Y = 0), move it up
      if (ornamentMinY < 0) {
        currentSelectedOrnament.position.y -= ornamentMinY;
      }
    }
  });

  // Add event listeners to OrbitControls to manage the isOrbiting flag
  controls.addEventListener('start', () => {
    isOrbiting = true;
    console.log('OrbitControls: start orbiting');
  });

  controls.addEventListener('end', () => {
    // Introduce a slight delay before resetting isOrbiting to handle rapid interactions
    setTimeout(() => {
      isOrbiting = false;
      console.log('OrbitControls: end orbiting');
      console.log('Camera Position:', controls)
    }, 100); // 100 milliseconds delay
  });

  transformControls.addEventListener('mouseDown', () => {
    controls.enabled = false;
  });

  transformControls.addEventListener('mouseUp', () => {
    controls.enabled = true;
  });
  
  transformControls.addEventListener('touchStart', () => {
    controls.enabled = false;
  });
  
  transformControls.addEventListener('touchEnd', () => {
    controls.enabled = true;
  });

  // Event listener for slider changes
  const overlapSlider = document.getElementById('overlapSlider');
  overlapSlider.addEventListener('input', function () {
    const sliderValue = parseFloat(this.value); // Get slider value (-50 to 50)
    
    // Map the slider value to a speed (-0.05 to 0.05, adjust as needed)
    currentSpeed = sliderValue * 0.01;
  
    // Start animation if it's not already running
    if (!animationFrameId) {
      previousTimestamp = performance.now(); // Initialize timestamp
      animationFrameId = requestAnimationFrame(updateMeshPosition);
    }
  });

  // Stop the overlap Animation When Slider Returns to 0
  overlapSlider.addEventListener('change', function () {
    if (parseFloat(this.value) === 0) {
      // Stop the animation when the slider is at 0
      cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
      currentSpeed = 0; // Reset the speed
    }
  });

  // Detect when the user stops dragging the slider (mouse or touch)
  overlapSlider.addEventListener('mouseup', resetSlider); // Mouse release
  overlapSlider.addEventListener('touchend', resetSlider); // Touch release

  // Event listener for the OK button within the overlap modal (For startOverlapAdjustment)
  document.getElementById('overlapOkButton').addEventListener('click', function () {
    // Move to the next character
    currentCharacterIndex++;
  
    // Hide the modal
    document.getElementById('overlapModal').style.display = 'none';

    // Revert text transparency to fully opaque
    setTextTransparency(1); // Reset opacity to 1 (fully opaque)
    removeHighlightFromAllCharacters();

    // Save the new offsets to the global variable for the entire text to
    textMeshes.forEach((mesh, index) => {
      const globalIndex = textMeshes.indexOf(mesh);
      if (globalIndex !== -1) {
        characterOffsets[globalIndex] = mesh.position.clone().sub(textMeshes[0].position);
      }
    });
    // Set the positionModified flag to true to allow using saved offsets if text or font haven't changed
    positionModified = true;
    console.log('characterOffsets after positioning:', characterOffsets);
  
    // Proceed to the next character if available
    if (currentCharacterIndex < textMeshes.length) {
      startOverlapAdjustment(currentCharacterIndex); // Pass the updated character index
    } else {
      console.log('All characters adjusted.');
      currentCharacterIndex = 1;
      //endOverlapAdjustment(); // function to switch from Ortho Camera back to the default camera
      updateCameraCenter();

      // When finishing the overlap adjustment, show the orbit controls modal ONLY if it hasn't been shown before (currentInstructionIndex === 0)
      if (currentInstructionIndex === 0){
        showOrbitControlsModal(); 
      }
    }
  });


  // Event listener for the BACK button within the overlap modal (For startOverlapAdjustment)
  document.getElementById('overlapBackButton').addEventListener('click', function () {
    if(currentCharacterIndex > 1)
    {
      // Move to the previous character
      currentCharacterIndex--;
  
      // Hide the modal
      document.getElementById('overlapModal').style.display = 'none';

      // Revert text transparency to fully opaque
      setTextTransparency(1); // Reset opacity to 1 (fully opaque)
      removeHighlightFromAllCharacters();

      // Save the new offsets to the global variable for the entire text to
      textMeshes.forEach((mesh, index) => {
        const globalIndex = textMeshes.indexOf(mesh);
        if (globalIndex !== -1) {
          characterOffsets[globalIndex] = mesh.position.clone().sub(textMeshes[0].position);
        }
      });
      // Set the positionModified flag to true to allow using saved offsets if text or font haven't changed
      positionModified = true;
      console.log('characterOffsets after positioning:', characterOffsets);
  
      // Proceed to the previous character if available
      if (currentCharacterIndex >= 1) {
        startOverlapAdjustment(currentCharacterIndex); // Pass the updated character index
      }
    }
  });

  

  // Event listener for the button inside the Orbit Controls Modal
  document.getElementById('orbitControlsButton').addEventListener('click', function () {
    currentInstructionIndex++;
    if (currentInstructionIndex < instructions.length) {
      updateOrbitControlsModal();
    } else {
      // Close the modal when the last instruction is done
      document.getElementById('orbitControlsModal').style.display = 'none';
    }
  });


  
}


// Add ground plane and lighting to the scene
function addSceneElements() {
  // Ground plane to receive shadows
  const planeGeometry = new THREE.PlaneGeometry(1000, 1000);
  const planeMaterial = new THREE.ShadowMaterial({ color: 0x000000, opacity: 0.5 });
  const plane = new THREE.Mesh(planeGeometry, planeMaterial);
  plane.rotation.x = -Math.PI / 2; // Rotate to be horizontal
  plane.position.y = 0; // Slightly below the text
  plane.receiveShadow = true; // Receive shadows
  scene.add(plane);

  // Directional light directly in front of the text to illuminate the front face
  const frontLight = new THREE.DirectionalLight(0xffffff, 0.5);  // Light intensity of 0.8 (adjust as needed)
  frontLight.position.set(0, 0, 10);  // Positioned in front of the text along the Z-axis
  frontLight.target.position.set(0, 0, 0);  // Target the center of the scene (text)
  scene.add(frontLight);
  scene.add(frontLight.target);

  // Directional light to cast shadows
  const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
  directionalLight.position.set(5, 10, 7.5); // Position the light
  directionalLight.castShadow = true; // Enable shadows from this light
  // Configure shadow properties for better quality
  directionalLight.shadow.mapSize.width = 1024;
  directionalLight.shadow.mapSize.height = 1024;
  directionalLight.shadow.camera.near = 0.5;
  directionalLight.shadow.camera.far = 500;
  directionalLight.shadow.camera.left = -50;
  directionalLight.shadow.camera.right = 50;
  directionalLight.shadow.camera.top = 50;
  directionalLight.shadow.camera.bottom = -50;
  scene.add(directionalLight);
  
  // Additional directional light to reduce harsh shadows
  const additionalDirectionalLight = new THREE.DirectionalLight(0xffffff, 0.2);  // Slightly lower intensity
  additionalDirectionalLight.position.set(-5, 5, -7.5);  // Position opposite to the main light
  scene.add(additionalDirectionalLight);

  // Ambient light for subtle illumination
  const ambientLight = new THREE.AmbientLight(0xffffff, 0.1); // Low intensity
  scene.add(ambientLight);

  // Hemisphere light for more realistic ambient lighting
  const hemisphereLight = new THREE.HemisphereLight(0xffffff, 0x444444, 0.1);  // Sky color (white), ground color (gray)
  hemisphereLight.position.set(0, 20, 0);  // Position high above the scene
  scene.add(hemisphereLight);

  // Create a helper sphere to show the click point in 3D space
  clickMarker.visible = false; // Hide by default
  scene.add(clickMarker);
}

// Animation loop
function animate() {
  requestAnimationFrame(animate);
  controls.update(); // Update controls
  // transformControls.update(); // For TransformControls

  // Enforce Z position constraint
  if (currentSelectedOrnament) {
    currentSelectedOrnament.position.z = currentSelectedOrnament.userData.fixedZ;
  }

  renderer.render(scene, camera); // Render the scene
}

// Handle window resize events
function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();

  renderer.setSize(window.innerWidth, window.innerHeight);
}

// Render the 3D text when called
function render3DText() {
   if (isFirstRender) return; // Skip rendering on the first load
  
  // Use the new modal input field for text input
  const userInput = document.getElementById('userTextInput').value.trim() || 'Hello'; // New modal input field
  //const fontName = document.getElementById('fontSelect').value;
  const errorMessage = document.getElementById('error-message');
  errorMessage.textContent = ''; // Clear previous errors

  // Get the selected color from the modal (or default to the first available color)
  selectedColor = getColorForNewText(); // Use the new helper function for color selection
  console.log('render3DText: selectedColor:', selectedColor);

  if (!selectedColor) {
    console.error('Failed to get the selected color properties.');
    errorMessage.textContent = 'Failed to load the selected color properties.';
    return;
  }

  // Remove existing text meshes and bounding boxes from the scene
  textMeshes.forEach((mesh) => {
    textGroup.remove(mesh);
  });
  bboxHelpers.forEach((helper) => {
    scene.remove(helper);
  });
  textMeshes = [];
  bboxHelpers = [];
  previousDepth = null; // Reset previous depth

  // Check if the name OR font has changed

  console.log('userInput: ', userInput);
  console.log('previousRenderedName: ', previousRenderedName);
  console.log('selectedFontName: ', selectedFontName);
  console.log('previousFontName: ', previousFontName);

  
   if (userInput !== previousRenderedName || selectedFontName !== previousFontName) {
    currentCharacterIndex = 1; //If the name or font have changed, always start overlapping from the second character
    previousRenderedName = userInput; // Update the last rendered name
    previousFontName = selectedFontName; // Update the last rendered font
    
    characterOffsets = new Array(userInput.split('').length).fill(new THREE.Vector3(0, 0, 0)); // Initialize characterOffsets to store positions for each character
    positionModified = false;
     
    console.log('Character offsets on Text creation: ', characterOffsets);
    console.log('Name or font changed, updating camera position and loading font');

    // Check if the font is already loaded
    if (loadedFonts[selectedFontName]) {
      createTextMeshes(loadedFonts[selectedFontName], userInput, selectedColor, startOverlapAdjustment); // Pass the color object
      //updateCameraCenter();
    } else {
      const fontLoader = new THREE.FontLoader();

      // Load the selected font
      fontLoader.load(
        selectedFontFile,
        function (font) {
          loadedFonts[selectedFontName] = font; // Cache the loaded font
          createTextMeshes(font, userInput, selectedColor, startOverlapAdjustment);
          //updateCameraCenter();
        },
        undefined,
        function (err) {
          console.error('An error occurred while loading the font:', err);
          errorMessage.textContent = 'Failed to load the selected font.';
        }
      );
    }
     
  } else {
    console.log('Name and font unchanged, no need to update camera position');
    createTextMeshes(loadedFonts[selectedFontName], userInput, selectedColor);
  }

  // Show the "Ornaments" and "Export STL" buttons after rendering text
  document.getElementById('ornamentsButton').style.display = 'block';
  //document.getElementById('exportButton').style.display = 'block';
}


// Create and position text meshes based on user input and overlap percentage
function createTextMeshes(font, userInput, selectedColor, callback) {
  const chars = userInput.split('');
  const textMaterial = new THREE.MeshStandardMaterial({
    color: new THREE.Color(selectedColor.hexColor),  // Use hexColor from selectedColor
    metalness: selectedColor.metallic,               // Use metallic property from selectedColor
    roughness: selectedColor.roughness,              // Use roughness property from selectedColor,
    transparent: true,
    opacity: 1,
    blending: THREE.NormalBlending,  // Try AdditiveBlending or MultiplyBlending
    depthWrite: true,  // Disable depth writing for transparency overlap
  });

  // Array to store character widths
  const charWidths = [];

  // DEPRECATED - Overlap slider not used anymore. Get the overlap percentage from the slider
  //const overlapPercentage = parseFloat(document.getElementById('overlapSlider').value) / 100;

  // Reset previousDepth for each new render
  previousDepth = null;

  // Clear existing meshes from the group
  while (textGroup.children.length > 0) {
    textGroup.remove(textGroup.children[0]);
  }

  // Clear existing arrays
  textMeshes = [];
  bboxHelpers.forEach((helper) => {
    scene.remove(helper);
  });
  bboxHelpers = [];

  // First pass: Create meshes and store depths and widths
  chars.forEach((char, index) => {
    // Set depth: 0.3 for first character, else random between 0.1 and 0.3 with validation
    let depth;
    if (index === 0) {
      depth = 0.3;
    } else {
      depth = generateValidDepth(previousDepth);
    }
    previousDepth = depth; // Update previousDepth for the next character

    // Create BufferGeometry directly from the text
    const textGeometry = new THREE.TextBufferGeometry(char, {
      font: font,
      size: 1,
      height: depth,
      curveSegments: 12,
      bevelEnabled: false,
    });

    // Merge vertices using BufferGeometryUtils with an adjustable tolerance
    const tolerance = 1e-4;  // Adjust this value to merge vertices within a larger tolerance
    const mergedGeometry = THREE.BufferGeometryUtils.mergeVertices(textGeometry, tolerance);

    // Adjust for descenders
    const descenders = ['g', 'j', 'p', 'q', 'y'];
    mergedGeometry.computeBoundingBox();
    let bbox = mergedGeometry.boundingBox;
    if (descenders.includes(char.toLowerCase())) {
      const scaleY = bbox.max.y / (bbox.max.y - bbox.min.y);
      mergedGeometry.scale(1, scaleY, 1);
      mergedGeometry.translate(0, -bbox.min.y, 0);
      mergedGeometry.computeBoundingBox();
      bbox = mergedGeometry.boundingBox;
    }

    // Create mesh
    const textMesh = new THREE.Mesh(mergedGeometry, textMaterial);
    textMesh.castShadow = true;
    textMesh.receiveShadow = false;

    // Compute bounding box to get character width
    textMesh.updateMatrixWorld(true);
    const meshBoundingBox = new THREE.Box3().setFromObject(textMesh);
    const characterWidth = meshBoundingBox.max.x - meshBoundingBox.min.x;
    charWidths.push(characterWidth);

    // **New Step: Align Bounding Box Bottom to Y = 0**
    const minY = meshBoundingBox.min.y;
    textMesh.position.y -= minY; // Translate mesh upward by minY to align bottom to Y=0

    // Update bounding box after translation
    textMesh.updateMatrixWorld(true);
    const updatedBoundingBox = new THREE.Box3().setFromObject(textMesh);
    const updatedMinY = updatedBoundingBox.min.y;

    // Store depth and width as userData
    textMesh.userData = {
      depth: depth,
      width: characterWidth,
    };

    // Add mesh to the group
    textGroup.add(textMesh);

    // Add mesh to the array
    textMeshes.push(textMesh);

    // Create BoxHelper
    //const bboxHelper = new THREE.BoxHelper(textMesh, 0xff0000); // Red color for bounding box
    //bboxHelper.update();
    //scene.add(bboxHelper);
    //bboxHelpers.push(bboxHelper);
    
  });

  // Second pass: Position the meshes based on previously saved offsets
  console.log('positionModified', positionModified);
  if (characterOffsets.length === chars.length && positionModified === true) {
    // Use saved offsets to position the meshes
    textMeshes.forEach((mesh, index) => {
      mesh.position.copy(characterOffsets[index]);
    });
  } else {
    // If there are no saved offsets or the number of characters has changed, use default positioning
    let prevMesh = null;

    textMeshes.forEach((mesh, index) => {
      if (index === 0) {
        mesh.position.x = 0; // Position the first character
      } else {
        const prevMesh = textMeshes[index - 1];
        const prevCharWidth = prevMesh.geometry.boundingBox.max.x - prevMesh.geometry.boundingBox.min.x;
        mesh.position.x = prevMesh.position.x + prevCharWidth + 0.1; // Default spacing
      }
    });
  }

  textMeshes.forEach((mesh, index) => {
    // Store the initial X position in userData
    mesh.userData.basePositionX = mesh.position.x;
  });

  // Check the color limit when adding a new text
  checkColorLimit();

  // Call the callback function after creating all meshes
  if (callback) {
    callback();
  }

  // No centering to prevent interference
}



// Generate a valid depth ensuring a minimum percentage change from the previous depth
function generateValidDepth(previousDepth) {
  const MAX_DEPTH = 0.3;
  const MIN_DEPTH = 0.15;
  const MIN_CHANGE = MIN_DEPTH_CHANGE_PERCENTAGE / 100; // Convert percentage to decimal

  let newDepth;
  let attempts = 0;
  const MAX_ATTEMPTS = 10; // Prevent infinite loops

  do {
    newDepth = Math.random() * (MAX_DEPTH - MIN_DEPTH) + MIN_DEPTH;
    attempts++;

    if (previousDepth === null) {
      // No previous depth to compare with
      break;
    }

    const lowerBound = previousDepth * (1 + MIN_CHANGE);
    const upperBound = previousDepth * (1 - MIN_CHANGE);

    // Check if newDepth is outside the X% range
    if (newDepth >= lowerBound || newDepth <= upperBound) {
      break;
    }
  } while (attempts < MAX_ATTEMPTS);

  return newDepth;
}

// Function to populate the ornaments grid
function populateOrnamentsGrid() {
  const ornamentGrid = document.getElementById('customOrnamentGrid'); // Use the correct ID for the ornament grid

  // Clear existing ornaments in the grid
  ornamentGrid.innerHTML = '';

  availableOrnaments.forEach((ornament, index) => {
    const img = document.createElement('img');
    img.src = ornament.thumbnailPath;
    img.alt = ornament.name;
    img.classList.add('custom-ornament-item');
    img.dataset.index = index; // Store index for reference

    // Add click event listener for selection
    img.addEventListener('click', () => {
      // Remove 'selected' class from all ornaments
      document.querySelectorAll('.custom-ornament-item').forEach((item) => {
        item.classList.remove('selected');
      });

      // Add 'selected' class to the clicked ornament
      img.classList.add('selected');

      // Set the selected ornament
      selectedOrnament = ornament;

      // Enable the add button
      document.getElementById('addOrnamentButton').disabled = false;
    });

    // Append the ornament to the grid
    ornamentGrid.appendChild(img);
  });
}

// Function to open the ornaments modal
function openOrnamentsModal() {
  console.log('Attempt to display the Ornaments Modal')
  document.getElementById('custom-ornamentsModal').style.display = 'flex';
}

// Function to close the ornaments modal
function closeOrnamentsModal() {
  document.getElementById('custom-ornamentsModal').style.display = 'none';

  // Clear selection
  document.querySelectorAll('.custom-ornament-item').forEach((item) => {
    item.classList.remove('selected');
  });
  selectedOrnament = null;

  // Disable the add button
  document.getElementById('addOrnamentButton').disabled = true;
}

function addOrnamentToScene() {
  if (!selectedOrnament) return; // Exit if no ornament is selected

  // Strip query parameters from the file URL
  const basePath = selectedOrnament.modelPath.split('?')[0];
  const fileExtension = basePath.split('.').pop().toLowerCase();

  if (fileExtension === 'stl') {
    loadSTLOrnament(basePath); // STL loader
  } else if (fileExtension === 'gltf' || fileExtension === 'glb') {
    loadGLTFOrnament(basePath); // GLTF loader
  } else if (fileExtension === 'obj') {
    const mtlFilePath = selectedOrnament.mtlPath.split('?')[0]; // Strip query params for MTL file
    loadOBJOrnament(basePath, mtlFilePath); // Load OBJ with MTL
  } else {
    console.error('Unsupported file format:', fileExtension);
  }
}

// Function to load STL ornaments
function loadSTLOrnament(filePath) {
  const loader = new THREE.STLLoader();

  loader.load(
    filePath,
    function (geometry) {
      // Define material for the ornament
      const material = new THREE.MeshStandardMaterial({
        color: 0x888888,    // Gray color; adjust as needed
        metalness: 0.5,     // Metallic appearance
        roughness: 0.5,     // Surface roughness
      });

      // **Step 1: Align Ornament's Rear Face to Origin (Z = 0)**

      // Compute the bounding box of the geometry
      geometry.computeBoundingBox();
      const ornamentBoundingBox = geometry.boundingBox;

      // Calculate ornament depth along Z-axis
      const ornamentDepth = ornamentBoundingBox.max.z - ornamentBoundingBox.min.z;

      // Translate geometry so that the rear face aligns with Z = 0
      // Assuming the rear face is at minZ
      geometry.translate(0, 0, -ornamentBoundingBox.min.z);

      // **Step 2: Create the Ornament Mesh**
      const ornamentMesh = new THREE.Mesh(geometry, material);
      ornamentMesh.castShadow = true;    // Enable casting shadows
      ornamentMesh.receiveShadow = true; // Enable receiving shadows

      // **Step 3: Analyze and Scale Ornament if Necessary**

      // Calculate ornament height
      const ornamentHeight = ornamentBoundingBox.max.y - ornamentBoundingBox.min.y;

      // Retrieve the tallest text height to determine scaling
      const tallestTextHeight = getTallestCharacterHeight();

      let scaleFactor = 1; // Default scale factor

      // If the ornament is taller than the text, scale it down
      if (ornamentHeight > tallestTextHeight) {
        scaleFactor = tallestTextHeight / ornamentHeight;
        ornamentMesh.scale.set(scaleFactor, scaleFactor, scaleFactor);
        console.log(`Ornament scaled by factor: ${scaleFactor}`);
      }

      // **Store the base scale for future reference**
      ornamentMesh.userData.baseScale = scaleFactor;

      // **Step 4: Position the Ornament**

      // Since the origin is at the rear face (Z = 0), set Z to 0
      ornamentMesh.position.set(
        0,
        -ornamentBoundingBox.min.y * scaleFactor, // Align bottom to Y = 0
        0                                       // Rear face at Z = 0
      );

      // **Store the Fixed Z Position**
      ornamentMesh.userData.fixedZ = 0; // Rear face remains at Z = 0

      // **Step 5: Add Ornament to the Scene and Tracking Arrays**

      // Add the ornament mesh to the ornaments group
      ornamentsGroup.add(ornamentMesh);

      // Track the ornament mesh for selection and other interactions
      ornamentMeshes.push(ornamentMesh);

      // **Step 6: Create and Add BoxHelper for Visual Bounding Box (Optional)**
      //const bboxHelper = new THREE.BoxHelper(ornamentMesh, 0x00ff00); // Green color for visibility
      //bboxHelper.update(); // Update the helper to match the mesh's current state
      //scene.add(bboxHelper); // Add the helper to the scene
      //bboxHelpers.push(bboxHelper); // Track the helper for future reference

      // **Step 7: Attach TransformControls to the Newly Added Ornament**
      transformControls.showY = true;
      transformControls.attach(ornamentMesh);
      currentSelectedOrnament = ornamentMesh; // Update the currentSelectedOrnament
      console.log(`TransformControls attached to: ${ornamentMesh.name}`);
      

      // **Step 8: Reset OrbitControls After Attachment to Prevent Orbiting Issues**
      controls.enabled = false;
      requestAnimationFrame(() => { controls.enabled = true; });

      // **Step 9: Close the Ornaments Modal (Assumes closeOrnamentsModal is Defined)**
      closeOrnamentsModal();
    },
    undefined,
    function (error) {
      console.error('An error occurred while loading the STL ornament:', error);
      alert('Failed to load the selected STL ornament.');
    }
  );
}

function loadGLTFOrnament(filePath) {
  const loader = new THREE.GLTFLoader();

  loader.load(
    filePath,
    function (gltf) {
      if (!gltf || !gltf.scene) {
        console.error('No scene found in the GLTF model.');
        alert('Failed to load the ornament: No scene found in the GLTF model.');
        return;
      }

      // Extract the scene from the GLTF model
      const ornamentScene = gltf.scene;

      // Create a new group to hold all ornament meshes
      const ornamentGroup = new THREE.Group();
      //ornamentGroup.name = filePath.split('/').pop().split('.')[0]; // Assign a name based on the file name
      ornamentGroup.name = selectedOrnament.name // Ensure the mesh inherits the same name as in the ornaments declaration section

      try {
        // Traverse and extract all meshes into the ornament group
        ornamentScene.traverse(function (child) {
          if (child && child.isMesh) {
            console.log(`Mesh found: ${child.name}`);

            // Apply default material if needed
            child.castShadow = true;
            child.receiveShadow = true;

            // Clone the mesh to avoid mutating the original glTF scene
            const clonedMesh = child.clone();
            ornamentGroup.add(clonedMesh);
          } else if (child && child.isGroup) {
            // If the child is a group, we need to traverse it recursively
            child.children.forEach((nestedChild) => {
              if (nestedChild && nestedChild.isMesh) {
                console.log(`Nested Mesh found: ${nestedChild.name}`);
                nestedChild.castShadow = true;
                nestedChild.receiveShadow = true;
                
                // Clone the nested mesh to avoid mutating the original glTF scene
                const clonedMesh = nestedChild.clone();
                ornamentGroup.add(clonedMesh);
              }
            });
          }
        });
      } catch (error) {
        console.error('An error occurred while traversing the GLTF model:', error);
        alert('Failed to load the ornament: An unexpected error occurred while traversing the GLTF model.');
        return;
      }

      // Ensure ornamentGroup contains meshes before proceeding
      if (ornamentGroup.children.length === 0) {
        console.error('No meshes found in the GLTF model.');
        alert('Failed to load the ornament: No meshes found in the GLTF model.');
        return;
      }

      // Compute bounding box and align the ornament group
      const bbox = new THREE.Box3().setFromObject(ornamentGroup);
      const minY = bbox.min.y;

      // **Step 1: Align Ornament's Rear Face to Origin (Z = 0)**
      ornamentGroup.position.set(0, -minY, -bbox.min.z);

      // **Step 2: Analyze and Scale Ornament to Match the Tallest Character's Height**

      // Calculate ornament height
      const ornamentHeight = bbox.max.y - bbox.min.y;
      console.log(`Ornament height: ${ornamentHeight}`);

      // Retrieve the tallest text height to determine scaling
      const tallestTextHeight = getTallestCharacterHeight();
      console.log(`Tallest text height: ${tallestTextHeight}`);

      // Calculate scale factor based on the tallest character
      let scaleFactor = tallestTextHeight / ornamentHeight;

      // Apply the scaling factor to the ornament group
      ornamentGroup.scale.set(scaleFactor, scaleFactor, scaleFactor);
      console.log(`Ornament scaled by factor: ${scaleFactor}`);

      // **Store the base scale for future reference**
      ornamentGroup.userData.baseScale = scaleFactor;

      // **Step 3: Position the Ornament Group**
      ornamentGroup.position.set(
        0,
        -bbox.min.y * scaleFactor, // Align bottom to Y = 0
        0                          // Rear face at Z = 0
      );
      console.log('positioning the ornament to:', [0,-bbox.min.y * scaleFactor,0]);

      // If the ornament's minimum Y is below the bottom plane (Y = 0), adjust it
      /*console.log('Ornament minY:', minY);
      if (minY < 0) {
        console.log('Moving the ornament because it is bwlow the Z plane by:', minY);
        ornamentGroup.position.y -= minY; // Move the ornament up by the amount it's below the plane
      }*/

      // **Store the Fixed Z Position**
      ornamentGroup.userData.fixedZ = 0;

      // Store whether the ornament color can be modified
      const selectedOrnamentData = availableOrnaments.find(ornament => ornament.name === selectedOrnament.name);
      ornamentGroup.userData.modifiableMaterial = selectedOrnamentData.modifiableMaterial;

      // **Step 4: Add Ornament Group to the Scene and Tracking Arrays**
      ornamentsGroup.add(ornamentGroup);
      ornamentMeshes.push(ornamentGroup); // Track the group as a single ornament

      // **Step 5: Create and Add BoxHelper for Visual Bounding Box (Optional)**
      const bboxHelper = new THREE.BoxHelper(ornamentGroup, 0x00ff00); // Green color for visibility
      bboxHelper.update(); // Update the helper to match the group's current state
      //scene.add(bboxHelper); // Add the helper to the scene
      bboxHelpers.push(bboxHelper); // Track the helper for future reference

      // **Step 6: Attach TransformControls to the Newly Added Ornament Group**
      /*transformControls.attach(ornamentGroup);
      currentSelectedOrnament = ornamentGroup; // Update the currentSelectedOrnament
      console.log(`TransformControls attached to: ${ornamentGroup.name}`);*/

      // **Step 7: Reset OrbitControls After Attachment to Prevent Orbiting Issues**
      controls.enabled = false;
      requestAnimationFrame(() => { controls.enabled = true; });

      // **Step 7.5: Set the initial color for the Ornament regardless of the original color of the model
      initialOrnamentColorSelection(ornamentGroup, selectedOrnament.initialColor);

      // **Step 8: Close the Ornaments Modal (Assumes closeOrnamentsModal is Defined)**
      closeOrnamentsModal();


      // Check the color limit when adding a new ornament
      checkColorLimit();
    },
    undefined,
    function (error) {
      console.error('An error occurred while loading the GLTF ornament:', error);
      alert('Failed to load the selected GLTF ornament.');
    }
  );
}

// Function to load OBJ ornaments
function loadOBJOrnament(filePath, mtlFilePath) {
  const loader = new THREE.OBJLoader();
  const mtlLoader = new THREE.MTLLoader();

  // Strip query parameters from file paths if present
  filePath = filePath.split('?')[0];
  mtlFilePath = mtlFilePath.split('?')[0];

  // Load the MTL file first
  mtlLoader.load(
    mtlFilePath,
    function (materials) {
      try {
        materials.preload();
        loader.setMaterials(materials);
        loader.load(
          filePath,
          function (object) {
            // Create a new group to hold all ornament meshes
            const ornamentGroup = new THREE.Group();

            try {
              // Traverse and extract all meshes into the ornament group
              object.traverse(function (child) {
                if (child && child.isMesh) {
                  console.log(`Mesh found: ${child.name}`);

                  // Apply default material if needed
                  child.castShadow = true;
                  child.receiveShadow = true;

                  // Clone the mesh to avoid mutating the original OBJ scene
                  const clonedMesh = child.clone();

                  // Adjust the material properties manually
                  if (clonedMesh.material) {
                    adjustMaterialProperties(clonedMesh.material);
                  }

                  ornamentGroup.add(clonedMesh);
                } else if (child && child.isGroup) {
                  // If the child is a group, we need to traverse it recursively
                  child.children.forEach((nestedChild) => {
                    if (nestedChild && nestedChild.isMesh) {
                      console.log(`Nested Mesh found: ${nestedChild.name}`);
                      nestedChild.castShadow = true;
                      nestedChild.receiveShadow = true;

                      // Clone the nested mesh to avoid mutating the original OBJ scene
                      const clonedMesh = nestedChild.clone();

                      // Adjust the material properties manually
                      if (clonedMesh.material) {
                        adjustMaterialProperties(clonedMesh.material);
                      }

                      ornamentGroup.add(clonedMesh);
                    }
                  });
                }
              });
            } catch (error) {
              console.error('An error occurred while traversing the OBJ model:', error);
              alert('Failed to load the ornament: An unexpected error occurred while traversing the OBJ model.');
              return;
            }

            // Ensure ornamentGroup contains meshes before proceeding
            if (ornamentGroup.children.length === 0) {
              console.error('No meshes found in the OBJ model.');
              alert('Failed to load the ornament: No meshes found in the OBJ model.');
              return;
            }

            // Compute bounding box and align the ornament group
            const bbox = new THREE.Box3().setFromObject(ornamentGroup);
            const minY = bbox.min.y;

            // **Step 1: Align Ornament's Rear Face to Origin (Z = 0)**
            ornamentGroup.position.set(0, -minY, -bbox.min.z);

            // **Step 2: Analyze and Scale Ornament to Match the Tallest Character's Height**

            // Calculate ornament height
            const ornamentHeight = bbox.max.y - bbox.min.y;
            const tallestTextHeight = getTallestCharacterHeight();
            const scaleFactor = tallestTextHeight / ornamentHeight;
            ornamentGroup.scale.set(scaleFactor, scaleFactor, scaleFactor);

            // **Store the base scale for future reference**
            ornamentGroup.userData.baseScale = scaleFactor;

            // **Step 3: Position the Ornament Group**
            ornamentGroup.position.set(
              0,
              -bbox.min.y * scaleFactor, // Align bottom to Y = 0
              0
            );

            // If the ornament's minimum Y is below the bottom plane (Y = 0), adjust it
            if (minY < 0) {
              ornamentGroup.position.y -= minY;
            }

            // **Store the Fixed Z Position**
            ornamentGroup.userData.fixedZ = 0;

            // **Step 4: Add Ornament Group to the Scene and Tracking Arrays**
            ornamentsGroup.add(ornamentGroup);
            ornamentMeshes.push(ornamentGroup);

            // **Step 5: Create and Add BoxHelper for Visual Bounding Box (Optional)**
            const bboxHelper = new THREE.BoxHelper(ornamentGroup, 0x00ff00);
            bboxHelper.update();
            bboxHelpers.push(bboxHelper);

            // **Step 6: Attach TransformControls to the Newly Added Ornament Group**
            transformControls.attach(ornamentGroup);
            currentSelectedOrnament = ornamentGroup;
            console.log(`TransformControls attached to: ${ornamentGroup.name}`);

            // **Step 7: Reset OrbitControls After Attachment to Prevent Orbiting Issues**
            controls.enabled = false;
            requestAnimationFrame(() => { controls.enabled = true; });

            // **Step 8: Close the Ornaments Modal (Assumes closeOrnamentsModal is Defined)**
            closeOrnamentsModal();

            // Check the color limit when adding a new ornament
            checkColorLimit();
          },
          undefined,
          function (error) {
            console.error('An error occurred while loading the OBJ ornament:', error);
            alert('Failed to load the selected OBJ ornament.');
          }
        );
      } catch (error) {
        console.error('An unexpected error occurred while loading materials:', error);
        alert('Failed to load the associated MTL file due to an unexpected error.');
      }
    },
    function (progressEvent) {
      console.error('An error occurred while loading the MTL file:', progressEvent);
      alert('Failed to load the associated MTL file for the OBJ ornament.');
    }
  );
}




// Function to export the scene to STL
function exportSTL() {
  if (textMeshes.length === 0 && ornamentMeshes.length === 0) return; // No objects to export

  const exporter = new THREE.STLExporter();

  // **Ensure geometries are transformed and indexed before merging**
  const mergedGeometries = [
    ...textMeshes,
    ...ornamentMeshes
  ].map(mesh => {
    mesh.updateMatrixWorld(true); // Apply world transformations

    // Clone the geometry and apply its transformation matrix
    const geometry = mesh.geometry.clone().applyMatrix4(mesh.matrixWorld);

    // Ensure the geometry is indexed to avoid attribute conflicts during merge
    if (!geometry.index) {
      geometry.setIndex(Array.from({ length: geometry.attributes.position.count }, (v, k) => k));
    }

    return geometry;
  });

  try {
    // Merge the transformed geometries
    const mergedGeometry = THREE.BufferGeometryUtils.mergeBufferGeometries(mergedGeometries, false);

    // Create a merged mesh with the material of the first mesh (or default if none exists)
    const mergedMesh = new THREE.Mesh(mergedGeometry, textMeshes.length > 0 ? textMeshes[0].material : new THREE.MeshStandardMaterial());

    const stlString = exporter.parse(mergedMesh);

    // Create a Blob from the STL string
    const blob = new Blob([stlString], { type: 'application/octet-stream' });
    const link = document.createElement('a');
    link.style.display = 'none';
    document.body.appendChild(link);
    link.href = URL.createObjectURL(blob);
    link.download = '3d-text-and-ornaments.stl';
    link.click();

    // Cleanup the link after download
    URL.revokeObjectURL(link.href);
    link.remove();

  } catch (error) {
    console.error('Error during STL export:', error);
    alert('Failed to export STL. Please ensure all objects are compatible.');
  }
}

// Function to export the scene to OBJ with MTL materials
function exportOBJ() {
  if (textMeshes.length === 0 && ornamentMeshes.length === 0) return; // No objects to export

  const exporter = new THREE.OBJExporter();
  const exportGroup = new THREE.Group();

  // Track added meshes to avoid duplication
  const addedMeshes = new Set();
  const addedMeshNames = new Set();

  // Add text meshes to the group
  textMeshes.forEach(mesh => {
    if (!addedMeshes.has(mesh.uuid)) {
      const clonedMesh = mesh.clone(); // Clone the mesh to avoid modifying the original
      clonedMesh.geometry = mesh.geometry.clone(); // Clone geometry
      exportGroup.add(clonedMesh);
      addedMeshes.add(mesh.uuid);
    }
  });

  // Add ornament meshes to the group
  ornamentMeshes.forEach(ornament => {
    if (ornament.isGroup) {
      // If the ornament is a group, traverse its children and add only unique meshes
      ornament.traverse((child) => {
        if (child.isMesh && !addedMeshes.has(child.uuid)) {
          const baseName = child.name.split('.')[0];
          if (!addedMeshNames.has(baseName)) {
            const clonedMesh = child.clone(); // Clone the mesh to avoid modifying the original
            clonedMesh.geometry = child.geometry.clone(); // Clone geometry
            exportGroup.add(clonedMesh);
            addedMeshes.add(child.uuid);
            addedMeshNames.add(baseName);
          }
        }
      });
    } else if (ornament.isMesh && !addedMeshes.has(ornament.uuid)) {
      const baseName = ornament.name.split('.')[0];
      if (!addedMeshNames.has(baseName)) {
        const clonedMesh = ornament.clone(); // Clone the mesh to avoid modifying the original
        clonedMesh.geometry = ornament.geometry.clone(); // Clone geometry
        exportGroup.add(clonedMesh);
        addedMeshes.add(ornament.uuid);
        addedMeshNames.add(baseName);
      }
    }
  });

  // Assign unique material names to each mesh based on its UUID
  const materials = {};
  exportGroup.traverse((child) => {
    if (child.isMesh && child.material) {
      const material = child.material;
      const materialName = `material_${material.uuid}`;
      materials[materialName] = material; // Track the material

      // Assign the material name to the mesh
      child.material.name = materialName;
    }
  });

  // Export OBJ data
  let objData = exporter.parse(exportGroup);

  // Get the text from the input field to use as the file name
  const userInput = document.getElementById('userTextInput').value || '3d-model';

  // Add reference to the MTL file at the beginning of the OBJ file
  objData = `mtllib ${userInput}.mtl\n` + objData;

  // Generate the MTL content
  const mtlData = createMTLContent(materials);

  // Create the zip file using JSZip
  const zip = new JSZip();
  zip.file(`${userInput}.obj`, objData); // Add the OBJ file to the zip
  zip.file(`${userInput}.mtl`, mtlData); // Add the MTL file to the zip

  // Generate the zip file and trigger download
  zip.generateAsync({ type: 'blob' }).then(function (content) {
    const zipBlob = new Blob([content], { type: 'application/zip' });
    const zipLink = document.createElement('a');
    zipLink.style.display = 'none';
    document.body.appendChild(zipLink);
    zipLink.href = URL.createObjectURL(zipBlob);
    zipLink.download = `${userInput}.zip`; // Download the zip file with the text name
    zipLink.click();

    // Clean up the DOM after download
    document.body.removeChild(zipLink);
  });
}

// Function to export the scene to OBJ with MTL materials for API integration
function exportOBJForAPI() {
  if (textMeshes.length === 0 && ornamentMeshes.length === 0) return; // No objects to export

  const exporter = new THREE.OBJExporter();
  const exportGroup = new THREE.Group();

  // Track added meshes to avoid duplication
  const addedMeshes = new Set();
  const addedMeshNames = new Set();

  // Add text meshes to the group
  textMeshes.forEach(mesh => {
    if (!addedMeshes.has(mesh.uuid)) {
      const clonedMesh = mesh.clone(); // Clone the mesh to avoid modifying the original
      clonedMesh.geometry = mesh.geometry.clone(); // Clone geometry
      exportGroup.add(clonedMesh);
      addedMeshes.add(mesh.uuid);
    }
  });

  // Add ornament meshes to the group
  ornamentMeshes.forEach(ornament => {
    if (ornament.isGroup) {
      // If the ornament is a group, traverse its children and add only unique meshes
      ornament.traverse((child) => {
        if (child.isMesh && !addedMeshes.has(child.uuid)) {
          const baseName = child.name.split('.')[0];
          if (!addedMeshNames.has(baseName)) {
            const clonedMesh = child.clone(); // Clone the mesh to avoid modifying the original
            clonedMesh.geometry = child.geometry.clone(); // Clone geometry
            exportGroup.add(clonedMesh);
            addedMeshes.add(child.uuid);
            addedMeshNames.add(baseName);
          }
        }
      });
    } else if (ornament.isMesh && !addedMeshes.has(ornament.uuid)) {
      const baseName = ornament.name.split('.')[0];
      if (!addedMeshNames.has(baseName)) {
        const clonedMesh = ornament.clone(); // Clone the mesh to avoid modifying the original
        clonedMesh.geometry = ornament.geometry.clone(); // Clone geometry
        exportGroup.add(clonedMesh);
        addedMeshes.add(ornament.uuid);
        addedMeshNames.add(baseName);
      }
    }
  });

  // Assign unique material names to each mesh based on its UUID
  const materials = {};
  exportGroup.traverse((child) => {
    if (child.isMesh && child.material) {
      const material = child.material;
      const materialName = `material_${material.uuid}`;
      materials[materialName] = material; // Track the material

      // Assign the material name to the mesh
      child.material.name = materialName;
    }
  });

  // Export OBJ data
  let objData = exporter.parse(exportGroup);

  // Get the text from the input field to use as the file name
  const userInput = document.getElementById('userTextInput').value || '3d-model';

  // Add reference to the MTL file at the beginning of the OBJ file
  objData = `mtllib ${userInput}.mtl\n` + objData;

  // Generate the MTL content
  const mtlData = createMTLContent(materials);

  // Create the zip file using JSZip
  const zip = new JSZip();
  zip.file(`${userInput}.obj`, objData); // Add the OBJ file to the zip
  zip.file(`${userInput}.mtl`, mtlData); // Add the MTL file to the zip

  // Generate the zip file and return it for API integration
  return zip.generateAsync({ type: 'blob' }).then(function (content) {
    return new Blob([content], { type: 'application/zip' });
  });
}

// Function to export the scene to GLB format
function exportGLB() {
  if (textMeshes.length === 0 && ornamentMeshes.length === 0) return; // No objects to export

  const exporter = new THREE.GLTFExporter();
  const exportGroup = new THREE.Group();

  // Add text meshes to the group
  textMeshes.forEach(mesh => {
    if (mesh.geometry && mesh.geometry.isBufferGeometry) { // Check if geometry is defined and is a BufferGeometry
      const clonedMesh = mesh.clone(); // Clone the mesh to avoid modifying the original
      clonedMesh.geometry = mesh.geometry.clone(); // Clone geometry
      if (clonedMesh.material) clonedMesh.material = mesh.material.clone(); // Clone material if it exists
      exportGroup.add(clonedMesh);
      console.log('Added text mesh to export group:', clonedMesh);
    } else {
      console.warn('Skipping text mesh due to invalid geometry:', mesh);
    }
  });

  // Add ornament meshes to the group, including handling groups of meshes
  ornamentMeshes.forEach(mesh => {
    if (mesh.isGroup) {
      mesh.children.forEach(child => {
        if (child.geometry && child.geometry.isBufferGeometry) {
          const clonedChild = child.clone();
          clonedChild.geometry = child.geometry.clone();
          if (clonedChild.material) clonedChild.material = child.material.clone();
          exportGroup.add(clonedChild);
          console.log('Added child mesh from ornament group to export group:', clonedChild);
        } else {
          console.warn('Skipping child mesh due to invalid geometry:', child);
        }
      });
    } else if (mesh.geometry && mesh.geometry.isBufferGeometry) { // Check if geometry is defined and is a BufferGeometry
      const clonedMesh = mesh.clone(); // Clone the mesh to avoid modifying the original
      clonedMesh.geometry = mesh.geometry.clone(); // Clone geometry
      if (clonedMesh.material) clonedMesh.material = mesh.material.clone(); // Clone material if it exists
      exportGroup.add(clonedMesh);
      console.log('Added ornament mesh to export group:', clonedMesh);
    } else {
      console.warn('Skipping ornament mesh due to invalid geometry:', mesh);
    }
  });

  // Ensure that the export group is not empty
  if (exportGroup.children.length === 0) {
    console.error('No valid meshes to export');
    alert('No valid meshes to export.');
    return;
  }

  // Get the text from the input field to use as the file name
  const userInput = document.getElementById('userTextInput').value || '3d-model';

  // Use promise-based approach for GLTFExporter to handle the output properly
  exporter.parse(
    exportGroup,
    function (result) {
      if (result instanceof ArrayBuffer) {
        console.log('GLB export successful:', result);
        const glbBlob = new Blob([result], { type: 'model/gltf-binary' });
        const glbLink = document.createElement('a');
        glbLink.style.display = 'none';
        document.body.appendChild(glbLink);
        glbLink.href = URL.createObjectURL(glbBlob);
        glbLink.download = `${userInput}.glb`;
        glbLink.click();
        // Clean up the DOM after download
        document.body.removeChild(glbLink);
      } else if (typeof result === 'object') {
        console.error('Unexpected data type received from GLTFExporter. Trying to process again.');
        // Create a Blob from the JSON data and retry saving
        const json = JSON.stringify(result);
        const gltfBlob = new Blob([json], { type: 'model/gltf+json' });
        const gltfLink = document.createElement('a');
        gltfLink.style.display = 'none';
        document.body.appendChild(gltfLink);
        gltfLink.href = URL.createObjectURL(gltfBlob);
        gltfLink.download = `${userInput}.gltf`;
        gltfLink.click();
        // Clean up the DOM after download
        document.body.removeChild(gltfLink);
      } else {
        console.error('Failed to export the model. Unexpected data type received:', result);
        alert('Failed to export the model. Unexpected data type received.');
      }
    },
    function (error) {
      console.error('An error occurred while exporting to GLB:', error);
      alert('Failed to export the model to GLB.');
    },
    { binary: true } // Export options to ensure binary output for GLB
  );
}

// Definition of the updateOverlap() function
function updateOverlap() {
  if (textGroup.children.length === 0) return; // No text to update

  const overlapPercentage = parseFloat(document.getElementById('overlapSlider').value) / 100;
  console.log(`Overlap Percentage Updated: ${overlapPercentage * 100}%`);

  let prevMesh = null;
  let prevCharRightEdge = 0;

  textGroup.children.forEach((mesh, index) => {
    const charWidth = mesh.userData.width;
    console.log(`Updating character ${index}: Width = ${charWidth}`);

    if (index === 0) {
      // First character position
      mesh.position.x = -mesh.geometry.boundingBox.min.x;
      console.log(`Character ${index} positioned at X = ${mesh.position.x}`);
    } else {
      // Get previous character's width
      const prevMesh = textGroup.children[index - 1];
      const prevCharWidth = prevMesh.userData.width;

      // Determine the narrower character
      const narrowerWidth = Math.min(charWidth, prevCharWidth);

      // Calculate overlap amount based on the narrower character
      const overlapAmount = overlapPercentage * narrowerWidth;

      // Position current character based on previous character's max.x
      mesh.position.x = prevMesh.position.x + prevMesh.geometry.boundingBox.max.x - overlapAmount - mesh.geometry.boundingBox.min.x;
      console.log(`Character ${index} positioned at X = ${mesh.position.x} with overlap amount = ${overlapAmount}`);
    }

    // Update previous character's right edge
    prevCharRightEdge = mesh.position.x + charWidth;
    prevMesh = mesh;

    // Update the corresponding BoxHelper
    if (bboxHelpers[index]) {
      bboxHelpers[index].update();
    }
  });

  // Adjust the camera's X position without changing Y and Z
  const bbox = new THREE.Box3().setFromObject(textGroup);
  const center = new THREE.Vector3();
  bbox.getCenter(center); // Get the center of the bounding box

  // Only update the X-axis to adjust camera position without resetting the full view
  controls.target.set(center.x, controls.target.y, controls.target.z);
  controls.update(); // Update OrbitControls
  
  
}

// Function to handle scaling via the scaleSlider
function handleScaleChange() {
  const scaleSlider = document.getElementById('scaleSlider');
  const scaleValue = document.getElementById('scaleValue');

  if (!scaleSlider || !scaleValue) {
    console.error('Scale slider elements not found in the DOM.');
    return;
  }

  // Add event listener for input changes on the scale slider
  scaleSlider.addEventListener('input', (event) => {
    // Prevent the event from bubbling up to parent elements
    event.stopPropagation();

    const sliderValue = parseFloat(scaleSlider.value);
    scaleValue.textContent = sliderValue.toFixed(1);

    if (currentSelectedOrnament) {
      // Retrieve the baseScale
      const baseScale = currentSelectedOrnament.userData.baseScale || 1;

      // Apply scaling based on the baseScale and slider value
      const newScale = baseScale * sliderValue;

      // Apply uniform scaling
      currentSelectedOrnament.scale.set(newScale, newScale, newScale);
    }
  });

  // Prevent mouse events on the slider from triggering the global click handler
  ['mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(eventType => {
    scaleSlider.addEventListener(eventType, (event) => {
      event.stopPropagation();
    });
  });
}


// Call handleScaleChange after the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Existing initialization code...

  // Initialize the scale slider functionality
  handleScaleChange();
});

// Function to get the height of the tallest text character
function getTallestCharacterHeight() {
  let tallestHeight = 0;
  
  textMeshes.forEach((mesh) => {
    mesh.geometry.computeBoundingBox();
    const height = mesh.geometry.boundingBox.max.y - mesh.geometry.boundingBox.min.y;
    if (height > tallestHeight) {
      tallestHeight = height;
    }
  });
  
  return tallestHeight;
}

// Function to highlight the selected ornament
function highlightSelectedOrnament(selectedMesh) {
  ornamentMeshes.forEach((mesh) => {
    const material = mesh.material;

    // Log visibility and material properties for debugging
    console.log(`Mesh visibility: ${mesh.visible}`);
    console.log(`Mesh material: `, material);

    // Check if the material has the emissive property before setting it
    if (material && material.emissive) {
      if (mesh === selectedMesh) {
        material.emissive.setHex(0x444444); // Highlight color (e.g., subtle gray)
      } else {
        material.emissive.setHex(0x000000); // Default emissive color (no highlight)
      }
    }
  });
}

// Function to handle mousedown event
function onMouseDown(event) {
  mouseDownPosition.set(event.clientX, event.clientY);
  isDragging = false;
  console.log('Mouse Down:', mouseDownPosition);
}

// Function to handle mousemove event
function onMouseMove(event) {
  if (!mouseDownPosition) return;
  
  const currentPosition = new THREE.Vector2(event.clientX, event.clientY);
  const movement = currentPosition.distanceTo(mouseDownPosition);
  
  if (movement > movementThreshold) {
    isDragging = true;
    //console.log('Dragging detected:', movement);
  }
}

// Function to handle mouseup event
function onMouseUp(event) {
  if (!isDragging && !isTransforming && !justDragged) {
    console.log('Click detected');
    handleClick(event);
  } else {
    console.log('Drag ended');
    console.log('Camera position on drag ended', camera.position);
  }
  
  // Reset mouse positions
  mouseDownPosition.set(0, 0);
  mouseUpPosition.set(0, 0);
}

// Function to handle click events for selecting/deselecting ornaments and text
function handleClick(event) {
  // Check if the click originated from a UI element
  if (event.target.closest('.ui')) {
    console.log('Click on UI element ignored');
    return;
  }

  const { x, y } = getMouseCoordinates(event);
  mouse.x = x;
  mouse.y = y;
  
  raycaster.setFromCamera(mouse, camera);
  
  // DEBUG: Update the ray helper on each click
  // Create a helper visualization of the ray for raycaster to detect intersections. Ray is casted in the handleClick function
  /*const rayHelper = new THREE.ArrowHelper(raycaster.ray.direction, raycaster.ray.origin, 5, 0x00ff00);
  scene.add(rayHelper);
  rayHelper.setDirection(raycaster.ray.direction);
  rayHelper.setLength(5); // Adjust length as needed
  */

  // Detect intersections with ornament meshes first
  const ornamentIntersects = raycaster.intersectObjects(ornamentMeshes, true);
  if (ornamentIntersects.length > 0) {
    const selectedMesh = ornamentIntersects[0].object;
    console.log('selectedMesh', selectedMesh);

    // Ensure that the selected object is indeed part of an ornament group
    const parentGroup = selectedMesh.parent;
    if (parentGroup && parentGroup.type === 'Group') {
      console.log('Ornament group clicked:', parentGroup);

      // Attach TransformControls to the entire group
      transformControls.showY = true;
      transformControls.attach(parentGroup);
      currentSelectedOrnament = parentGroup;

      // Adjust the size of the TransformControls gizmo to make it visually larger
      transformControls.size = 1.75;  // Default is 1, so increase to make it larger

      // Update scale slider with the current scale of the group
      const scaleSlider = document.getElementById('scaleSlider');
      const scaleValue = document.getElementById('scaleValue');
      const currentScale = parentGroup.scale.x / (parentGroup.userData.baseScale || 1);
      scaleSlider.value = currentScale;
      scaleValue.textContent = currentScale.toFixed(1);

      // Focus the renderer's DOM element to capture slider interactions
      renderer.domElement.focus();

      // Show the ornament control popup
      toggleOrnamentPopup(true);

      // Check if the selected ornament allows material modification
      const selectedOrnamentData = availableOrnaments.find(ornament => ornament.name === parentGroup.name);
      console.log('selected ornament name', parentGroup.name);
      console.log('selectedOrnamentData', selectedOrnamentData);
      console.log('modifiableMaterial', selectedOrnamentData.modifiableMaterial);
      
      if (selectedOrnamentData && selectedOrnamentData.modifiableMaterial) {
        // Show the color button if the ornament supports material modification
        document.getElementById('ornamentColorButton').style.display = 'block';
        
        populateOrnamentColorList();
        const currentHex = `#${selectedMesh.material.color.getHexString()}`;
        const matchingColor = availableColors.find(color => color.hexColor.toLowerCase() === currentHex.toLowerCase());
      
        if (matchingColor) {
          console.log(`Ornament color matched to: ${matchingColor.name}`);
        } else {
          console.log('No color match found. Defaulting to: Black');
        }
      
      } else {
        // Hide the color button if the ornament does not support material modification
        document.getElementById('ornamentColorButton').style.display = 'none';
      }

      // Prevent OrbitControls from handling this click
      event.preventDefault();
      event.stopPropagation();

      // Reset OrbitControls to prevent lingering "orbiting" state
      controls.enabled = false;
      requestAnimationFrame(() => { controls.enabled = true; });
      return; // Exit since an ornament group was handled
    }
  }

  // Detect intersections with text meshes if no ornament was clicked
  //UPDATE: We will no longer detect intersections with meshes as the update overlap happens with the modal now.
  /*
  const textIntersects = raycaster.intersectObjects(textMeshes, true);
  if (textIntersects.length > 0) {

    // DEBUG: Show and position the click marker at the intersection point
    
    //const intersectionPoint = textIntersects[0].point; // Get intersection point
    //clickMarker.position.copy(intersectionPoint);
    //clickMarker.visible = true; // Make the marker visible
    //console.log('Intersection point:', intersectionPoint);
    
    // DEBUG: Show and position the click marker at the intersection point
    
    const selectedMesh = textIntersects[0].object;
    const charIndex = textMeshes.indexOf(selectedMesh);
    console.log(`Text character clicked: Index ${charIndex}`);

    if (charIndex > 0 && !selectedGroup) {
      // Remove previous highlights
      removeHighlightFromAllCharacters();

      // Select the clicked character and all subsequent characters
      selectedGroup = textMeshes.slice(charIndex);
      console.log(`Characters selected from index ${charIndex} onwards:`, selectedGroup);

      // Highlight the selected group of characters
      highlightSelectedCharacters(selectedGroup);

      // Attach TransformControls to adjust the overlap of the selected group
      attachTransformControls(selectedGroup);
      transformControls.showY = false;
    }

    // Optional: Hide the marker after 2 seconds
    setTimeout(() => {
      clickMarker.visible = false;
    }, 2000);
    // Optional: Hide the marker after 2 seconds
    
    return;
  }*/

  // If no object is clicked, detach the TransformControls and reset the selected ornament/text
  removeHighlightFromAllCharacters();
  transformControls.detach();
  currentSelectedOrnament = null;
  selectedGroup = null;

  // Remove highlights
  highlightSelectedOrnament(null);

  // Reset the scale slider to default value
  const scaleSlider = document.getElementById('scaleSlider');
  const scaleValue = document.getElementById('scaleValue');
  scaleSlider.value = 1;
  scaleValue.textContent = '1';

  // Hide the ornament control popup
  toggleOrnamentPopup(false);

  // Reset and hide the color selection dropdown
  //document.getElementById('colorSelectionContainer').style.display = 'none';
  console.log('No ornament or text character selected, selection cleared');

  // Reset OrbitControls to prevent lingering "orbiting" state
  controls.enabled = false;
  requestAnimationFrame(() => { controls.enabled = true; });
}







// DEPRECATED function. Not using a color dropdown anymore. 
// Populate the color dropdown with the available colors
/*
function populateColorDropdown(colorSelect) {

  // Clear the current options
  colorSelect.innerHTML = '';

  // Loop through the available colors and add them as options
  availableColors.forEach((color) => {
    const option = document.createElement('option');
    option.value = color.hexColor;  // Use hex color as the value

    // Set the color name as the text content
    option.textContent = `${color.name}`;

    // Apply custom CSS to show the color swatch as the background
    option.style.backgroundColor = color.hexColor;

    // If the background is white, set the text color to black for readability
    if (color.hexColor.toLowerCase() === '#ffffff') {
      option.style.color = '#000'; // Black text for white background
    } else {
      option.style.color = '#fff'; // White text for other backgrounds
    }

    // Add the option to the dropdown
    colorSelect.appendChild(option);
  });
}
*/

function getSelectedColorProperties(selectedColorName) {
  // Find the selected color in the availableColors list by its name
  const selectedColor = availableColors.find(color => color.name === selectedColorName);

  if (selectedColor) {
    console.log('Selected Color:', selectedColor.name);
    console.log('Color Code:', selectedColor.hexColor);
    console.log('Metallic:', selectedColor.metallic);
    console.log('Roughness:', selectedColor.roughness);

    // Return the color properties
    return {
      color: new THREE.Color(selectedColor.hexColor), // Use THREE.Color for setting material color
      metalness: selectedColor.metallic,
      roughness: selectedColor.roughness
    };
  }

  // If no color is found, return null or default values
  return {
    color: new THREE.Color(0xffffff), // Default white
    metalness: 0.5,
    roughness: 0.5
  };
}

// Function to toggle the visibility of the ornament control popup
function toggleOrnamentPopup(visible) {
  const popup = document.getElementById('ornamentControlPopup');
  popup.style.display = visible ? 'block' : 'none';
}

function populateOrnamentColorDropdown() {
  const colorSelect = document.getElementById('ornamentColorSelect');
  colorSelect.innerHTML = ''; // Clear previous options

  // Populate dropdown with available colors
  availableColors.forEach(color => {
    const option = document.createElement('option');
    option.value = color.name;
    option.textContent = color.name;

    // Apply the background color to the option
    option.style.backgroundColor = color.hexColor;

    // If the color is white, set the text color to black for visibility
    if (color.hexColor.toLowerCase() === '#ffffff') {
      option.style.color = '#000000'; // Black text for white background
    } else {
      option.style.color = '#ffffff'; // White text for other backgrounds
    }

    colorSelect.appendChild(option);
  });
}

function updateCameraCenter() {
  // Calculate the bounding box of the text group
  const bbox = new THREE.Box3().setFromObject(textGroup);
  const center = new THREE.Vector3();
  const originalCenter = new THREE.Vector3();
  bbox.getCenter(center); // Get the center of the bounding box
  bbox.getCenter(originalCenter)
  const size = bbox.getSize(new THREE.Vector3()); // Get the size of the bounding box

  // Detect mobile or desktop using touch event detection
  let yOffset = 0; // Default no offset
  let zoomFactor = 1.5; // Default zoom factor for desktop
  
  if ('ontouchstart' in window || navigator.maxTouchPoints) {
    // It's a mobile or touch-based device
    yOffset = 0; // Adjust this for mobile view
    zoomFactor = 5; // Increase zoom out factor for mobile view
  } else {
    // It's a desktop or non-touch device
    yOffset = -0.2; // Adjust this for desktop view
    zoomFactor = 2; // Default zoom factor for desktop
  }

  // Adjust camera to focus on the center of the text with Y offset
  center.y += yOffset; // Apply Y offset
  controls.target.set(center.x, 0, center.z);

  // Set the camera position based on the size of the text
  const maxSize = Math.max(size.x, size.y, size.z); // Get the largest dimension of the text
  const idealDistance = maxSize * zoomFactor; // Adjust this factor for ideal framing
  camera.position.set(center.x, 0, idealDistance); // Set the camera position further back
  // Manually adjust the Y value to lift the camera a bit higher
  // camera.position.set(center.x, center.y + maxSize * 0.1, idealDistance); // Adjust the 0.1 factor as needed

  camera.updateProjectionMatrix(); // Ensure the projection matrix is updated
  controls.update(); // Update OrbitControls with the new target and position
  console.log('Camera', camera);
  console.log('Controls Target', controls.target);
}

// Function to update the text color without re-rendering the text
function updateTextColor(selectedColor) {
  if (textMeshes.length > 0) {
    textMeshes.forEach((mesh) => {
      console.log('Selected color and properties:', [
        selectedColor.name,
        selectedColor.hexColor,
        selectedColor.metallic,
        selectedColor.roughness,
      ]);
      mesh.material.color.set(selectedColor.hexColor);
      mesh.material.metalness = selectedColor.metallic;
      mesh.material.roughness = selectedColor.roughness;
      mesh.material.needsUpdate = true; // Ensure the material is updated
    });
    console.log('Text color updated to:', selectedColor.name);
  } else {
    console.log('No text loaded. Color selection is inactive until text is rendered.');
  }
}

// Custom function to create MTL content from materials
function createMTLContent(materials) {
  let mtlContent = '';

  Object.keys(materials).forEach((materialName) => {
    const material = materials[materialName];

    // Add material properties to the MTL content
    mtlContent += `newmtl ${materialName}\n`;
    mtlContent += `Ns 250.0\n`; // Specular highlight (shininess), matching Blender
    mtlContent += `Ka 0.2 0.2 0.2\n`; // Ambient color
    mtlContent += `Kd ${material.color.r} ${material.color.g} ${material.color.b}\n`; // Diffuse color
    mtlContent += `Ks 0.5 0.5 0.5\n`; // Specular color
    mtlContent += `Ke 0.0 0.0 0.0\n`; // Emissive color
    mtlContent += `Ni 1.0\n`; // Optical density (index of refraction)
    mtlContent += `d 1.0\n`; // Transparency (1.0 = fully opaque)
    mtlContent += `illum 3\n\n`; // Illumination model (3 for ray-trace & phong shading)
  });

  return mtlContent;
}

// Function to merge vertices by distance (replicating "Merge by Distance" in Blender)
function mergeVerticesByDistance(geometry, distanceThreshold = 1e-5) {
  // Ensure the geometry is a BufferGeometry
  if (!(geometry instanceof THREE.BufferGeometry)) {
    console.log('geometry is a BufferGeometry')
    geometry = new THREE.BufferGeometry().fromGeometry(geometry);
  } else {
    console.log('geometry is NOT a BufferGeometry')
  }

  // Apply mergeVertices to remove close vertices
  geometry = THREE.BufferGeometryUtils.mergeVertices(geometry, distanceThreshold);

  // Recompute the normals and bounding box after merging vertices
  geometry.computeVertexNormals();
  geometry.computeBoundingBox();

  return geometry;
}

function getUniqueColorsInScene() {
  const uniqueColors = new Set();

  // Check text meshes
  textMeshes.forEach(mesh => {
    const color = mesh.material.color.getHexString();
    uniqueColors.add(color);
  });

  // Check ornament meshes
  ornamentMeshes.forEach(ornament => {
    if (ornament.isGroup) {
      // Traverse the group and check all child meshes
      ornament.traverse((child) => {
        if (child.isMesh && child.material && child.material.color) {
          const color = child.material.color.getHexString();
          uniqueColors.add(color);
        } else if (child.isMesh && child.userData.presetColors) {
          // For non-material-modifiable ornaments, count their preset colors
          child.userData.presetColors.forEach(color => {
            uniqueColors.add(color);
          });
        }
      });
    } else if (ornament.isMesh) {
      // If ornament is a single mesh, handle it directly
      if (ornament.material && ornament.material.color) {
        const color = ornament.material.color.getHexString();
        uniqueColors.add(color);
      } else if (ornament.userData.presetColors) {
        // For non-material-modifiable ornaments, count their preset colors
        ornament.userData.presetColors.forEach(color => {
          uniqueColors.add(color);
        });
      }
    }
  });

  return uniqueColors;
}

function checkColorLimit() {
  const uniqueColors = getUniqueColorsInScene();
  const uniqueColorCount = uniqueColors.size;
  uniqueColorCountGlobal = uniqueColorCount;
  uniqueColorsGlobal = uniqueColors;

  if (uniqueColorCount > 4) {
      // Disable export button and display a warning
      document.getElementById('exportButton').disabled = true;
      document.getElementById('addToCartButton').disabled = true;
      showWarning();
  } else {
      // Enable export button
      document.getElementById('exportButton').disabled = false;
      hideWarning(); // Make sure to hide any existing warning
  }
}

function showWarning() {
  const warningElement = document.getElementById('colorWarning');
  if (warningElement) {
    warningElement.style.display = 'block';
  }
}

function hideWarning() {
  const warningElement = document.getElementById('colorWarning');
  if (warningElement) {
    warningElement.style.display = 'none';
  }
}

// Update camera and renderer size on window resize
function onWindowResize() {
  const headerHeight = document.querySelector('header').offsetHeight;
  const availableHeight = window.innerHeight - headerHeight;

  camera.aspect = window.innerWidth / availableHeight;
  camera.updateProjectionMatrix();

  renderer.setSize(window.innerWidth, availableHeight);
}

// Function to adjust the scene-container size dynamically, accounting for Safari's address bar
function adjustSceneContainerSize() {
  const mobileHeader1 = document.querySelector('.tt-mobile-header');
  const desktopHeader1 = document.querySelector('.tt-desktop-header');
  const mobileHeaderDisplayStyle = window.getComputedStyle(mobileHeader1).display;
  const desktopHeaderDisplayStyle = window.getComputedStyle(desktopHeader1).display;

  const headerHeight = document.querySelector('.tt-mobile-header')?.offsetHeight || document.querySelector('.tt-desktop-header')?.offsetHeight || 0;
  const uiHeight = document.querySelector('.ui')?.offsetHeight || 0;

  // Use visualViewport height for Apple devices (for better handling of address bar in Safari)
  let viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;

  if (isAppleDevice()) {
    // For Apple devices, get the smaller of the visualViewport height and the original viewport height (to avoid resizing issues)
    viewportHeight = Math.min(originalViewportHeight, window.visualViewport.height);

    // Scroll back to the top after keyboard hides
    window.scrollTo(0, 0);
  }

  let availableHeight = 0;

  // Calculate available height for rendering area
  if (mobileHeaderDisplayStyle === 'block') {
    availableHeight = viewportHeight - headerHeight - uiHeight; // For mobile, subtract the header and UI height
  } else if (desktopHeaderDisplayStyle === 'block') {
    availableHeight = viewportHeight - headerHeight - uiHeight; // For desktop, subtract the header and UI height
  }

  // Set the height of the scene container
  const container = document.getElementById('scene-container');
  container.style.height = `${availableHeight}px`;

  // Update renderer size
  renderer.setSize(window.innerWidth, availableHeight);

  // Update camera aspect ratio
  camera.aspect = window.innerWidth / availableHeight;
  camera.updateProjectionMatrix();
}

// Function to recenter the camera to the scene container
function recenterCamera() {
  const container = document.getElementById('scene-container');
  const boundingRect = container.getBoundingClientRect();

  // Set camera position to look at the center of the scene container
  const centerY = (boundingRect.top + boundingRect.bottom) / 2;

  // Optionally adjust the camera position (Z) to ensure it's looking at the scene's center
  //camera.position.set(0, -5, 10); // Example: Centered X and Y, with Z at 5 units away
  //camera.lookAt(0, -5, 0); // Ensure the camera always looks at the origin or your target point

  renderer.render(scene, camera); // Re-render the scene
}

function createCrosshair(size = 0.1) {
  const material = new THREE.LineBasicMaterial({ color: 0xff0000 }); // Red color for visibility

  // Define the lines that form the crosshair (+ shape)
  const points = [
    new THREE.Vector3(-size, 0, 0),
    new THREE.Vector3(size, 0, 0),
    new THREE.Vector3(0, -size, 0),
    new THREE.Vector3(0, size, 0),
  ];

  const geometry = new THREE.BufferGeometry().setFromPoints(points);
  const crosshair = new THREE.LineSegments(geometry, material);

  return crosshair;
}

function addCrosshairToScene() {
  // Create the bounding box around the textGroup
  const box = new THREE.Box3().setFromObject(textGroup); // Get the bounding box of the textGroup

  // Create and add the crosshair at the origin (0, 0, 0)
  const crosshair = createCrosshair(0.5); // Adjust size as needed
  crosshair.position.set(0, 0, 0); // Place the crosshair at the origin
  scene.add(crosshair); // Add the crosshair to the scene

  // Create a bounding box helper with a green wireframe around the textGroup
  const boxHelper = new THREE.Box3Helper(box, new THREE.Color(0x00ff00)); // Green color
  scene.add(boxHelper); // Add the bounding box helper to the scene

  renderer.render(scene, camera); // Re-render the scene to display changes
}

// Attach transform controls to a group of selected characters
function attachTransformControls(selectedGroup) {
  if (!selectedGroup || selectedGroup.length === 0) return;

  // Attach TransformControls to the first character in the selected group
  const firstMesh = selectedGroup[0];
  transformControls.attach(firstMesh);
  console.log('Transform Controls attached to mesh: ', firstMesh);

  // Keep track of the initial positions of the group relative to the first character
  const relativeOffsets = selectedGroup.map((mesh, index) => {
    if (index === 0) return new THREE.Vector3(0, 0, 0); // The first character has no offset
    return mesh.position.clone().sub(firstMesh.position);
  });

  // Update global character offsets
  //characterOffsets = relativeOffsets;
  console.log('Relative offsets at the time of selection:', relativeOffsets);

  // Disable OrbitControls during the transformation to prevent conflicts
  //controls.enabled = false;

  // **Ensure transform controls have only one objectChange listener at a time**
  // Define the listener function separately so that we can remove it later
  if (typeof window.onObjectChangeListener !== 'undefined') {
    transformControls.removeEventListener('objectChange', window.onObjectChangeListener);
  }

  // Define and add the objectChange listener
  window.onObjectChangeListener = () => {
    //console.log('Transform Controls ObjectChange event listener for text translation entered');
    //console.log('Attempting to transform the mesh');
    //console.log('Selected Group: ', selectedGroup);
    //console.log('Relative Offsets: ', relativeOffsets);
    //console.log('First Mesh: ', firstMesh);
    //console.log('Is Transforming: ', isTransforming);
    isTransforming = true; // Set transforming flag to true during transformation
    
    // Check consistency of selectedGroup length
    //console.log('Current selectedGroup length:', selectedGroup.length);

    requestAnimationFrame(() => handleObjectChange(selectedGroup, relativeOffsets, firstMesh));
  };

  transformControls.addEventListener('objectChange', window.onObjectChangeListener);

  // Add a listener for the end of the transform action to re-enable OrbitControls
  const onEndListener = () => {
    controls.enabled = true;
    isTransforming = false; // Reset the transforming flag
    positionModified = true;
    console.log('Is Transforming: ', isTransforming);

    // Save the new offsets to the global variable for the entire text
    selectedGroup.forEach((mesh, index) => {
      const globalIndex = textMeshes.indexOf(mesh);
      if (globalIndex !== -1) {
        characterOffsets[globalIndex] = mesh.position.clone().sub(textMeshes[0].position);
      }
    });
    console.log('characterOffsets after positioning:', characterOffsets)

    textGroup.children.forEach((mesh, index) => {
      // Update the corresponding BoxHelper
      if (bboxHelpers[index]) {
        bboxHelpers[index].update();
      }
    });

    // Adjust the camera's X position without changing Y and Z
    /*
    const bbox = new THREE.Box3().setFromObject(textGroup);
    const center = new THREE.Vector3();
    bbox.getCenter(center); // Get the center of the bounding box
  
    // Only update the X-axis to adjust camera position without resetting the full view
    controls.target.set(center.x, controls.target.y, controls.target.z);
    controls.update(); // Update OrbitControls
    */
    
  };
  
  // Avoid adding duplicate listeners for `mouseup` and `touchend`
  if (typeof window.onEndListener !== 'undefined') {
    transformControls.removeEventListener('mouseUp', window.onEndListener);
    transformControls.removeEventListener('touchEnd', window.onEndListener);
  }

  window.onEndListener = onEndListener;
  transformControls.addEventListener('mouseUp', onEndListener);
  transformControls.addEventListener('touchEnd', onEndListener);

  // Ensure the renderer reflects the changes by updating the scene and camera
  renderer.render(scene, camera);
}


// Highlight selected group of characters
function highlightSelectedCharacters(selectedGroup) {
  //console.log('Highlighting selected characters:', selectedGroup);

  selectedGroup.forEach((mesh) => {
    // Clone the current material to avoid affecting all meshes using the same material
    const originalMaterial = mesh.material.clone();
    mesh.userData.originalMaterial = originalMaterial; // Store the original material in userData

    // Change color to highlight the character
    //mesh.material = originalMaterial.clone();
    //mesh.material.color.set(0xff0000); // Set to red to highlight

    // Check if the material has the emissive property before setting it
    mesh.material = originalMaterial.clone();
    mesh.material.emissive.setHex(0x8a8a8a); // Highlight color (e.g., subtle gray)
    mesh.material.emissiveIntensity = 0.7; // Increase emissive intensity for a glowing effect
    });
}

// Function to remove the highlight from all text meshes
function removeHighlightFromAllCharacters() {
  textMeshes.forEach((mesh) => {
    if (mesh.userData.originalMaterial) {
      mesh.material = mesh.userData.originalMaterial; // Restore the original material
      delete mesh.userData.originalMaterial; // Clean up the userData
    }
  });
}

  // Global function to handle changes during transformations
function handleObjectChange(selectedGroup, relativeOffsets, firstMesh) {
  if (!selectedGroup || !firstMesh) return;

  // Get the new position of the first character
  const newPosition = firstMesh.position;
  //console.log('New position of first character:', newPosition)

  // Update the position of each character in the group relative to the first one
  selectedGroup.forEach((mesh, index) => {
    if (index === 0) return; // Skip the first character
    const offset = relativeOffsets[index];
    mesh.position.copy(newPosition.clone().add(offset));
  });

  // Update the renderer to reflect changes immediately
  renderer.render(scene, camera);
}

// Helper function to adjust material properties
function adjustMaterialProperties(material) {
  // Manually adjust key properties to better match expectations
  material.metalness = 0.0; // Typically MTL materials lack this parameter
  material.roughness = 1.0; // Default to fully rough to avoid a shiny look

  // Adjust color using Kd (diffuse color)
  if (material.color && material.diffuse) {
    material.color.setRGB(material.diffuse.r, material.diffuse.g, material.diffuse.b);
  }

  // If the material has a shininess (Ns), map it to roughness (roughness is the inverse of shininess)
  if (material.shininess !== undefined) {
    material.roughness = 1.0 - Math.min(material.shininess / 1000, 1.0);
  }

  // Adjust transparency if the material's d (transparency) value is present
  if (material.opacity !== undefined) {
    material.transparent = material.opacity < 1.0;
  }
}

// Function for adding to cart and all it entails (ZIP generation, uploading, thumbnail, variant creation, and adding to cart)
async function addToCart() {
  //const productId = 8822460743901; // Replace with your actual product ID
  

  if (selectedSize === null) {
    const finalSelectedSize = await showSizesModal();
  }

  if (selectedSize !== null) {
    // Calculate subtotal and show summary modal before proceeding
    const proceed = await showSummaryModal();
  
    if (!proceed) {
      // User clicked "Volver", so stop here
      return;
    }
  
    // Gather customization data from the new UI controls
    const userText = document.getElementById('userTextInput').value.trim(); // New modal input field for text
  
    // Get selected font from the new font modal
    const selectedFont = selectedFontName; // `selectedFontName` is set from the font modal
  
    // Get selected text color from the new color modal
    const selectedTextColorHex = selectedColor.hexColor; // `selectedColor` is set in the color modal
    const selectedTextColorName = selectedColor.name;
  
    // Get ornament information
    let ornamentsData = [];
    ornamentMeshes.forEach(ornament => {
      if (ornament.userData.modifiableMaterial) {
        const ornamentGroupName = ornament.name;
        let colorName = null;
        ornament.traverse(child => {
          console.log('Traversing Ornaments - Current Child: ', child);
          if (child.isMesh && child.material && child.material.color) {
            const hexColor = `#${child.material.color.getHexString()}`;
            //colorName = availableColors.find(color => color.hexColor.toLowerCase() === hexColor.toLowerCase())?.name || 'Unknown';
            colorName = ornament.userData.color;
          }
        });
        ornamentsData.push({ name: ornamentGroupName, color: colorName });
      } else {
        ornamentsData.push({ name: ornament.name });
      }
    });
  
    // Generate unique file names using userText and the current timestamp
    const timestamp = Date.now();
    const sanitizedUserText = userText.replace(/[^a-zA-Z0-9]/g, '_');
    const zipFileName = `${sanitizedUserText}_${timestamp}.zip`;
    const thumbnailFileName = `${sanitizedUserText}_${timestamp}.png`;
  
    try {
      // Step 1: Export the customized model as a ZIP file
      showLoadingModal('Comprimiendo el modelo.');
      const zipBlob = await exportOBJForAPI(); // Use exportOBJForAPI() to return a Blob of the ZIP file
      console.log('Model exported: ', zipBlob);
  
      // Step 2: Upload the ZIP file to AWS S3
      updateLoadingStatus('Subiendo el modelo a la nube... 0% completado.');
      const uploadedZipUrl = await uploadFileToAWSWithProgress(zipFileName, zipBlob);
      console.log('Uploaded ZIP URL: ', uploadedZipUrl);
  
      // DEPRECATED Step 3: Create a new variant with customization details
      /*const newVariantId = await createNewVariant(productId, userText, selectedFont, selectedTextColorName, ornamentsData, uploadedZipUrl);
      console.log('New variant created with ID:', newVariantId);*/
  
      // Step 3: Capture and upload the thumbnail image for the new variant
      showLoadingModal('Capturando una foto del modelo.');
      const thumbnailBlob = await captureAndUploadThumbnail();
      const thumbnailUrl = await uploadPNGToAWS(thumbnailFileName, thumbnailBlob);
      console.log('Thumbnail uploaded: ', thumbnailUrl);
  
      // Step 4: Create a new variant with customization details
      showLoadingModal('Creando un nuevo producto.');
      const newVariantId = await createNewProductViaHeroku(userText, selectedFont, selectedTextColorName, selectedSize.size, selectedSize.basePrice, extraColors, extraColorsCost, ornamentCount, ornamentCost, ornamentsData, subtotal, uploadedZipUrl, thumbnailUrl)
      console.log('New variant created with ID:', newVariantId);
  
  
      // Step 5: Add the new variant to the cart
      showLoadingModal('Agregando el producto al carrito.');
      const properties = {
        'Texto Personalizado': userText,
        'Color del Texto': selectedTextColorName,
        'Tamaño': selectedSize.size,
        'Precio Base': selectedSize.basePrice,
        'Colores Adicionales': extraColors,
        'Precio de Colores Adicionales': extraColorsCost,
        'Adornos': ornamentCount,
        'Precio de Adornos': ornamentCost,
        'Total': subtotal,
        
        
      };
  
      ornamentsData.forEach((ornament, index) => {
        properties[`Ornament ${index + 1}`] = ornament.name;
        if (ornament.color) {
          properties[`Ornament ${index + 1} Color`] = ornament.color;
        }
      });
  
      const data = {
        items: [
          {
            id: newVariantId,
            quantity: 1,
            properties: properties,
          },
        ],
      };
  
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
  
      if (!response.ok) {
        throw new Error('Failed to add item to cart');
      }
  
      const responseData = await response.json();
      console.log('Item added to cart:', responseData);
      window.location.href = '/cart'; // Redirect the user to the cart page
      //alert('Item added to cart successfully!');
    } catch (error) {
      console.error('Error during add to cart process:', error);
      alert('Ocurrió un error durante el procesamiento.');
    }
    hideLoadingModal();
  }
}

// Helper Functions:

// Upload File to Shopify
async function uploadFileToShopify(zipFileName) {
  const formData = new FormData();
  formData.append('file', zipFileName); // This should be the Blob or File object

  const response = await fetch('/admin/api/2023-04/files.json', {
    method: 'POST',
    headers: {
      'X-Shopify-Access-Token': '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',
    },
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Failed to upload file to Shopify');
  }

  const data = await response.json();
  return data.file.public_url;
}

// Function to upload File to a AWS S3 Bucket
async function uploadFileToAWS(zipFileName, zipFileBlob) {
  try {
    // Generate a unique file name to prevent collision
    const uniqueFileName = `${Date.now()}-${zipFileName}`;

    const params = {
      Bucket: bucketName_var,
      Key: uniqueFileName,
      Body: zipFileBlob,
      ContentType: "application/zip",
      //ACL: "public-read", // Make it publicly accessible
    };

    // Upload to S3
    const response = await s3.upload(params).promise();
    console.log("File successfully uploaded to S3:", response.Location);

    // Return the public URL of the uploaded file
    return response.Location;
  } catch (error) {
    console.error("Error uploading file to S3:", error);
    throw error;
  }
}

// Function to upload a file to AWS S3 with progress tracking
async function uploadFileToAWSWithProgress(fileName, fileBlob) {
  try {
    const uniqueFileName = `${Date.now()}-${fileName}`;

    const params = {
      Bucket: bucketName_var,
      Key: uniqueFileName,
      Body: fileBlob,
      ContentType: fileBlob.type,
    };

    // Monitor upload progress
    return new Promise((resolve, reject) => {
      s3.upload(params)
        .on('httpUploadProgress', (progress) => {
          const percent = Math.round((progress.loaded / progress.total) * 100);
          console.log(`Upload Progress: ${percent}%`);
          updateLoadingStatus(`Subiendo el modelo a la nube... ${percent}% completado.`);
        })
        .send((error, data) => {
          if (error) {
            console.error('Error uploading file to S3:', error);
            reject(error);
          } else {
            console.log('File successfully uploaded to S3:', data.Location);
            resolve(data.Location);
          }
        });
    });
  } catch (error) {
    console.error('Error during S3 upload:', error);
    throw error;
  }
}


// Function to upload PNG to an AWS S3 Bucket
async function uploadPNGToAWS(pngFileName, pngFileBlob) {
  try {
    // Generate a unique file name to prevent collision
    const uniqueFileName = `${Date.now()}-${pngFileName}`;

    const params = {
      Bucket: bucketName_var,
      Key: uniqueFileName,
      Body: pngFileBlob,
      ContentType: "image/png",  // Content type set to PNG
      //ACL: "public-read", // Make it publicly accessible if needed
    };

    // Upload to S3
    const response = await s3.upload(params).promise();
    console.log("PNG file successfully uploaded to S3:", response.Location);

    // Return the public URL of the uploaded PNG file
    return response.Location;
  } catch (error) {
    console.error("Error uploading PNG to S3:", error);
    throw error;
  }
}

// Create New Product via Heroku
async function createNewProductViaHeroku(userText, font, textColor, size, basePrice, extraColors, colorCost, ornamentCount, ornamentCost, ornaments, subtotal, uploadedZipUrl, thumbnailUrl) {
  // Build the data object that will be sent to Heroku
  const data = {
    userText: userText,               // Custom text for the 3D model
    font: font,                       // Selected font
    textColor: textColor,             // Selected text color
    size: size,
    basePrice: basePrice,
    extraColors: extraColors,
    colorCost: colorCost,
    ornamentCount: ornamentCount,
    ornamentCost: ornamentCost,
    ornaments: ornaments,             // Array of ornament details
    subtotal: subtotal,
    s3_url: uploadedZipUrl,           // URL of the 3D model ZIP file in S3
    image: thumbnailUrl               // Thumbnail URL for the product
  };

  try {
    // Send the request to your Heroku app
    const response = await fetch('https://shopify-variant-creator-0b5a908e7e24.herokuapp.com/create_product', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    // Check if the response is not okay
    if (!response.ok) {
      throw new Error('Failed to create product via Heroku');
    }

    // Parse the response data from Heroku
    const responseData = await response.json();
    console.log('Product created via Heroku:', responseData);

    // Extract and return the product ID or variant ID from the nested structure
    const productId = responseData.product.product.id;
    const variantId = responseData.product.product.variants[0].id;

    console.log('Product ID:', productId);
    console.log('Variant ID:', variantId);

    // Return the variant ID (or product ID if needed)
    return variantId;  // Adjust as needed

  } catch (error) {
    console.error('Error during product creation via Heroku:', error);
    alert('An error occurred during product creation.');
    throw error;  // Rethrow the error for further handling
  }
}

// Function to capture the current scene as a thumbnail and return a Blob
async function captureAndUploadThumbnail() {
  return new Promise((resolve, reject) => {
    // Store the current camera position, orientation, and aspect ratio
    const originalPosition = camera.position.clone();
    const originalRotation = camera.rotation.clone();
    const originalAspect = camera.aspect;
    const originalRendererSize = { width: renderer.domElement.width, height: renderer.domElement.height };
    
    // Store the current target position
    const currentTarget = controls.target.clone();

    // Calculate the bounding box of the text group
    const bbox = new THREE.Box3().setFromObject(textGroup);
    const center = new THREE.Vector3();
    bbox.getCenter(center); // Get the center of the bounding box
    const size = bbox.getSize(new THREE.Vector3()); // Get the size of the bounding box
  
    // Detect mobile or desktop using touch event detection
    let yOffset = 0; // Default no offset
    let zoomFactor = 1.5; // Default zoom factor for desktop
    
    if ('ontouchstart' in window || navigator.maxTouchPoints) {
      yOffset = 0; // Mobile view adjustment
      zoomFactor = 5; // Increase zoom factor for mobile
    } else {
      yOffset = 0; // Desktop view adjustment
      zoomFactor = 3; // Default zoom factor for desktop
    }

    // Adjust camera to focus on the center of the text with Y offset
    center.y += yOffset;
    controls.target.copy(center);

    // Set the camera position based on the size of the text
    const maxSize = Math.max(size.x, size.y, size.z);
    const idealDistance = maxSize * zoomFactor;

    // Temporarily adjust the renderer size to 1080x1080 for the thumbnail
    renderer.setSize(1080, 1080);
    camera.aspect = 1; // Set aspect ratio to 1:1 (square)
    camera.updateProjectionMatrix(); // Ensure the projection matrix is updated

    // Set the camera to a predefined angle for consistent thumbnails
    camera.position.set(center.x, center.y, idealDistance);
    camera.lookAt(center); // Keep the camera pointed at the center

    // Render the scene with the adjusted settings
    renderer.render(scene, camera);

    // Capture the thumbnail from the canvas
    renderer.domElement.toBlob(function (blob) {
      if (blob) {
        // Restore the original camera settings
        camera.position.copy(originalPosition);
        camera.rotation.copy(originalRotation);
        controls.target.copy(currentTarget);
        controls.update();
        camera.aspect = originalAspect;
        camera.updateProjectionMatrix();

        // Restore the original renderer size
        renderer.setSize(originalRendererSize.width, originalRendererSize.height);
        renderer.render(scene, camera); // Re-render the scene with the original settings

        resolve(blob);
      } else {
        reject(new Error('Failed to capture thumbnail.'));
      }
    }, 'image/png');
  });
}


// Show loading modal and update status text
function showLoadingModal(status) {
  const loadingModal = document.getElementById('loading-modal');
  const loadingStatus = document.getElementById('loading-status');
  if (loadingStatus) loadingStatus.textContent = status;
  loadingModal.style.display = 'flex';
}

// Hide loading modal
function hideLoadingModal() {
  const loadingModal = document.getElementById('loading-modal');
  loadingModal.style.display = 'none';
}

// Function to update the loading status text in the modal
function updateLoadingStatus(status) {
  const loadingStatus = document.getElementById('loadingStatus');
  if (loadingStatus) {
    loadingStatus.textContent = status;
  }
}

// Adjust mouse coordinates considering possible offsets and NDC space
function getMouseCoordinates(event) {
  const boundingRect = renderer.domElement.getBoundingClientRect(); // Get canvas size and position

  // Calculate normalized device coordinates (-1 to +1 range)
  const mouseX = ((event.clientX - boundingRect.left) / boundingRect.width) * 2 - 1;
  const mouseY = -(((event.clientY - boundingRect.top) / boundingRect.height) * 2 - 1);

  return { x: mouseX, y: mouseY };
}

// Function to show the text input modal
function showTextModal() {
  textModal.style.display = 'flex';
}

// Function to hide the text input modal
function hideTextModal() {
  if (isFirstRender) return;
  textModal.style.display = 'none';
  adjustSceneContainerSize();
}

// Function to update the 3D text with user input
function update3DText() {
  const userText = userTextInput.value.trim();
  userTextInputforFontList = userText;
  console.log('userTextInputforFontList', userTextInputforFontList);
  if (userText) {
    render3DText(userText); // Call your existing render3DText function
  }
  hideTextModal();
}

// Function to show the color selection modal
function showColorModal() {
  colorModal.style.display = 'flex';
}

// Function to hide the color selection modal
function hideColorModal() {
  if (isFirstRender) return;
  colorModal.style.display = 'none';
}

// Populate the color list with available colors
function populateColorList() {
  colorList.innerHTML = ''; // Clear any previous entries

  availableColors.forEach((color) => {
    const listItem = document.createElement('div');
    listItem.className = 'color-list-item';
    listItem.textContent = color.name;
    listItem.style.backgroundColor = color.hexColor;

    // Adjust text color based on background brightness
    const brightness = parseInt(color.hexColor.slice(1), 16); // Convert hex to integer
    listItem.style.color = brightness > 0xffffff / 2 ? 'black' : 'white'; // Use black text for light colors

    // Special case for Jade White to add a black outline
    if (color.name.toLowerCase() === 'jade white') {
      listItem.style.border = '2px solid black'; // Add a black border for visibility
    }

    // Handle click event to select a color
    listItem.addEventListener('click', () => handleColorSelection(color));
    colorList.appendChild(listItem);
  });
}

// Handle color selection from the modal
function handleColorSelection(selectedColorFromModal) {
  console.log(`Selected color: ${selectedColorFromModal.name}`);

  // Store the selected color for new text or update the existing text immediately
  selectedColor = selectedColorFromModal;

  if (textMeshes.length > 0) {
    // If text is already rendered, apply the color immediately
    updateTextColor(selectedColor);
    checkColorLimit(); // Check color limit if applicable
  }

  // Close the modal after selection
  hideColorModal();
}

// Use the stored color when creating new text if available
function getColorForNewText() {
  return selectedColor || availableColors[0]; // Default to the first available color
}

// Function to populate the font list inside the modal
function populateFontList(userText) {
  
  fontList.innerHTML = ''; // Clear previous entries
  console.log('populateFontList version of userText', userText);

  availableFonts.forEach((font) => {
    const listItem = document.createElement('div');
    listItem.className = 'font-list-item';
    listItem.textContent = userText;

    // Apply the correct font family to each item
    listItem.style.fontFamily = font.name;

    listItem.addEventListener('click', () => handleFontSelection(font));
    fontList.appendChild(listItem);
  });
}

// Function to handle font selection
function handleFontSelection(selectedFont) {
  selectedFontName = selectedFont.name; // Store selected font name
  selectedFontFile = selectedFont.file; // Store the font file path

  // Close the font modal after selection
  fontModal.style.display = 'none';

  // If text is already rendered, re-render it with the new font
  if (textMeshes.length > 0) {
    render3DText();
  }
}

// Function to hide the color selection modal
function hideFontModal() {
  if (isFirstRender) return;
  fontModal.style.display = 'none';
}

// Function to hide the overlap slider modal
function hideOverlapModal() {
  overlapModal.style.display = 'none';
} 

// Function to show the Sizes modal
//function showSizesModal(){
//  document.getElementById('sizeModal').style.display = 'flex'; // Show modal
//}

// Function to hide the Sizes modal
function hideSizesModal(){
  document.getElementById('sizeModal').style.display = 'none'; // Show modal
}
  
function startOverlapAdjustment(currentCharacterIndex = 1) {
  console.log('Starting overlap adjustment at index:', currentCharacterIndex);

  // Set up orthographic camera if not already done
  /*if (!orthoCamera) {
    setupOrthoCamera();
  }

  // Replace current perspective camera with orthographic
  controls.object = orthoCamera;
  renderer.render(scene, orthoCamera);
  */

  if (currentCharacterIndex < textMeshes.length) {
    // Select the subset starting from the current character
    selectedGroup = textMeshes.slice(currentCharacterIndex);

    // Highlight the selected group if needed (you can uncomment if highlight logic is used)
    highlightSelectedCharacters(selectedGroup);

    // Position the camera on the current character
    positionCameraOnCharacter(currentCharacterIndex);

    // Make all the text meshes transparent for better overlap visibility
    setTextTransparency(0.7); // Set opacity to 0.5 (or any value between 0 and 1)

    // Show the overlap adjustment modal
    document.getElementById('overlapModal').style.display = 'flex';
    if(currentCharacterIndex === 1){
      document.getElementById('overlapBackButton').disabled = true;
    } else {
      document.getElementById('overlapBackButton').disabled = false;
    }

    // Example usage: Show a tooltip on a button with the id 'overlapSlider'
    //const overlapSlider = document.getElementById('overlapSlider');
    //showTooltip(overlapSlider, 'Use this slider to adjust overlap.');

    // Reset the slider value to 0
    document.getElementById('overlapSlider').value = 0;
  } else {
    console.log('Overlap adjustment completed!');
  }
}

// Utility function to check if the device is mobile and in portrait mode
function isMobilePortrait() {
  return /Mobi|Android/i.test(navigator.userAgent) && window.innerHeight > window.innerWidth;
}

// Function to position the camera on the current character
function positionCameraOnCharacter(index) {
  const targetMesh = textMeshes[index - 1];
  const bbox = new THREE.Box3().setFromObject(targetMesh);
  const center = bbox.getCenter(new THREE.Vector3());

  console.log('Focusing camera on character', targetMesh);
  console.log('character mesh center', center);

  // Define Y position based on device type and orientation
  const customYPosition = isMobilePortrait() ? -0.2 : 0; // Adjust this Y value for mobile portrait

  // Adjust camera to focus on the character's center
  controls.target.set(center.x, customYPosition, center.z);
  camera.position.set(center.x, customYPosition, center.z + 5); // Adjust Z for distance

  camera.updateProjectionMatrix();
  controls.update();

  console.log('Camera Target', controls.target);
  console.log('Camera Position', camera.position);

  renderer.render(scene, camera); // Re-render the scene
}

// Update mesh position based on current speed and deltaTime
function updateMeshPosition(timestamp) {
  const deltaTime = (timestamp - previousTimestamp) / 1000; // Convert to seconds
  previousTimestamp = timestamp;

  if (selectedGroup) {
    // Adjust the position of each mesh in the selected group
    selectedGroup.forEach((mesh) => {
      mesh.position.x += currentSpeed * deltaTime; // Move based on speed and deltaTime
    });

    // Get the leading character's bounding box center
    const leadingCharacter = textMeshes[currentCharacterIndex - 1];
    const boundingBox = new THREE.Box3().setFromObject(leadingCharacter);
    const center = new THREE.Vector3();
    boundingBox.getCenter(center); // Get the center of the bounding box

    // Determine Y position for camera target based on device and orientation
    const targetYPosition = isMobilePortrait() ? -0.2 : 0;

    // Smoothly update the camera position and target to track the leading character
    camera.position.x = center.x;
    controls.target.set(center.x, targetYPosition, center.z);

    // Update the camera and controls
    camera.updateProjectionMatrix();
    controls.update();

    // Re-render the scene with the updated camera and mesh positions
    renderer.render(scene, camera);
  }

  // Keep updating the position and camera in real-time
  animationFrameId = requestAnimationFrame(updateMeshPosition);
}

// Reset the slider and stop movement when the user releases the slider
function resetSlider() {
  overlapSlider.value = 0; // Reset slider value to 0
  currentSpeed = 0; // Stop the movement
  cancelAnimationFrame(animationFrameId); // Stop animation
  animationFrameId = null;
}



function startGuidedFlow() {
  // Open the text input modal first
  document.getElementById('textModal').style.display = 'flex';

  // Use a one-time event listener for text submission (first guided flow only)
  const submitTextHandler = () => {
    document.getElementById('textModal').style.display = 'none';
    adjustSceneContainerSize();
    document.getElementById('fontModal').style.display = 'flex';

    // Remove the listener after the first submission to avoid triggering again
    document.getElementById('submitTextButton').removeEventListener('click', submitTextHandler);
  };
  document.getElementById('submitTextButton').addEventListener('click', submitTextHandler);

  // Use a one-time listener for font selection
  const fontSelectHandler = () => {
    document.getElementById('fontModal').style.display = 'none';
    adjustSceneContainerSize();
    document.getElementById('colorModal').style.display = 'flex';
    populateColorList(); // Populate the color list each time the modal opens

    // Remove the listener after the first selection
    document.getElementById('fontList').removeEventListener('click', fontSelectHandler);
  };
  document.getElementById('fontList').addEventListener('click', fontSelectHandler);

  // Use a one-time listener for color selection
  const colorSelectHandler = () => {
    document.getElementById('colorModal').style.display = 'none';
    isFirstRender = false; // Set flag to false after initial guided flow

    // Show the overlap instructions modal before rendering the 3D text
    document.getElementById('overlapInstructionsModal').style.display = 'flex';
    document.getElementById('overlapInstructionsOkButton').addEventListener('click', () => {
      document.getElementById('overlapInstructionsModal').style.display = 'none';
      render3DText(); // Now render the 3D text after the guided flow
    });

    // Remove the listener to avoid it being called again unnecessarily
    document.getElementById('colorList').removeEventListener('click', colorSelectHandler);
  };
  document.getElementById('colorList').addEventListener('click', colorSelectHandler);
}

// Function to set text transparency
function setTextTransparency(opacityValue) {
  textMeshes.forEach((mesh) => {
    mesh.material.transparent = true;   // Enable transparency
    mesh.material.opacity = opacityValue; // Set the opacity value
    mesh.material.depthWrite = false;
    if (opacityValue === 1) {
      mesh.material.depthWrite = true;
      mesh.material.transparent = false;
    }
  });
  renderer.render(scene, camera); // Re-render the scene
}

function setupOrthoCamera() {
  console.log('Setting up the ortho camera');
  const aspect = window.innerWidth / window.innerHeight;
  const frustumSize = 10; // You can adjust this value to control the view size
  
  orthoCamera = new THREE.OrthographicCamera(
    frustumSize * aspect / -2, 
    frustumSize * aspect / 2, 
    frustumSize / 2, 
    frustumSize / -2, 
    0.1, 
    1000
  );
  
  orthoCamera.position.set(camera.position.x, camera.position.y, camera.position.z); // Match current perspective position
  orthoCamera.lookAt(controls.target); // Match the current target
}

// Function to switch back to perspective view after overlap adjustment
function endOverlapAdjustment() {
  // Switch back to the perspective camera
  controls.object = camera;
  renderer.render(scene, camera);
}

function showTooltip(element, message) {
  const tooltip = document.getElementById('tooltip');
  const tooltipContent = document.getElementById('tooltipContent');
  
  // Set the message inside the tooltip
  tooltipContent.textContent = message;

  // Get the position of the target element
  const rect = element.getBoundingClientRect();
  
  // Position the tooltip relative to the target element
  tooltip.style.top = `${rect.top + window.scrollY - 50}px`; // Adjust the `-50` for offset
  tooltip.style.left = `${rect.left + window.scrollX + (rect.width / 2) - 50}px`; // Adjust the `-50` for centering

  // Show the tooltip
  tooltip.style.display = 'block';

  // Hide the tooltip when user clicks or touches anywhere on the screen
  document.addEventListener('click', hideTooltip);
  document.addEventListener('touchstart', hideTooltip);
}

function hideTooltip() {
  const tooltip = document.getElementById('tooltip');
  tooltip.style.display = 'none';

  // Remove the event listeners once the tooltip is hidden
  document.removeEventListener('click', hideTooltip);
  document.removeEventListener('touchstart', hideTooltip);
}

// Populate the ornament color list with available colors
function populateOrnamentColorList() {
  const ornamentColorList = document.getElementById('ornamentColorList');
  ornamentColorList.innerHTML = ''; // Clear previous entries

  availableColors.forEach((color) => {
    const listItem = document.createElement('div');
    listItem.className = 'color-list-item';
    listItem.textContent = color.name;
    listItem.style.backgroundColor = color.hexColor;

    // Adjust text color based on background brightness
    const brightness = parseInt(color.hexColor.slice(1), 16); // Convert hex to integer
    listItem.style.color = brightness > 0xffffff / 2 ? 'black' : 'white'; // Use black text for light colors

   // Special case for Jade White to add a black outline
    if (color.name.toLowerCase() === 'jade white') {
      listItem.style.border = '2px solid black'; // Add a black border for visibility
    }

    // Handle click event to select a color for the ornament
    listItem.addEventListener('click', () => handleOrnamentColorSelection(color));
    ornamentColorList.appendChild(listItem);
  });
}

// Handle ornament color selection from the modal
function handleOrnamentColorSelection(selectedColorFromModal) {
  console.log(`Selected ornament color: ${selectedColorFromModal.name}`);

  if (currentSelectedOrnament) {
    // Get the selected color properties (like metallic and roughness)
    const { color, metalness, roughness } = getSelectedColorProperties(selectedColorFromModal.name);

    // Save the selected color in the metadata
    currentSelectedOrnament.userData.color = selectedColorFromModal.name;
    
    // Traverse the ornament and apply the color and material properties
    currentSelectedOrnament.traverse((child) => {
      if (child.isMesh) {
        child.material.color.set(color);
        child.material.metalness = metalness;
        child.material.roughness = roughness;
        child.material.needsUpdate = true;
      }
    });
  }

  // Check the color limit when selecting a new color for an ornament
  checkColorLimit();

  // Close the modal after selection
  hideOrnamentColorModal();
}

// Handle ornament color selection from the modal
function initialOrnamentColorSelection(ornamentGroup, initialColor_local) {
  // console.log(`Selected ornament: ${selectedOrnament.name}`);
  // console.log(`Selected ornament initial color: ${selectedOrnament.initialColor}`);
  if (initialColor_local !== '')
  {
    if (ornamentGroup) {
      // Get the selected color properties (like metallic and roughness)
      const { color, metalness, roughness } = getSelectedColorProperties(initialColor_local);

      ornamentGroup.userData.color = initialColor_local;
      
      // Traverse the ornament and apply the color and material properties
      ornamentGroup.traverse((child) => {
        if (child.isMesh) {
          child.material.color.set(color);
          child.material.metalness = metalness;
          child.material.roughness = roughness;
          child.material.needsUpdate = true;
        }
      });
    }
  }

  // Check the color limit when selecting a new color for an ornament
  checkColorLimit();

}

// Function to hide the ornament color modal
function hideOrnamentColorModal() {
  document.getElementById('ornamentColorModal').style.display = 'none';
}

// Function to update the ornament's color (this should apply the color change in your 3D scene)
function updateOrnamentColor(ornament) {
  if (ornament && ornament.mesh) {
    ornament.mesh.material.color.set(ornament.color.hexColor);
    renderer.render(scene, camera); // Re-render the scene to apply changes
  }
}

function adjustHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// Function to populate size buttons in the modal
function populateSizeButtons() {
  const sizeButtonGrid = document.querySelector('.size-button-grid');
  sizeButtonGrid.innerHTML = ''; // Clear previous buttons

  availableSizes.forEach((sizeOption) => {
    const button = document.createElement('button');
    button.className = 'size-button';
    
    // Create size name and price elements
    const sizeName = document.createElement('div');
    sizeName.className = 'size-name';
    sizeName.textContent = sizeOption.size;
    
    const sizePrice = document.createElement('div');
    sizePrice.className = 'size-price';
    sizePrice.textContent = `$${sizeOption.basePrice}`;
    
    // Append name and price to the button
    button.appendChild(sizeName);
    button.appendChild(sizePrice);
    
    // Add click event to select size and close modal
    button.addEventListener('click', () => {
      selectedSize = sizeOption; // Save the selected size
      document.getElementById('sizeModal').style.display = 'none'; // Close modal
      console.log(`Selected size: ${selectedSize.size}, Price: ${selectedSize.basePrice}`);
    });

    // Append the button to the grid
    sizeButtonGrid.appendChild(button);
  });
}

// Function to show the size selection modal and return the selected size
function showSizesModal() {
  return new Promise((resolve) => {
    // Display the size selection modal
    const sizeModal = document.getElementById('sizeModal');
    sizeModal.style.display = 'flex';

    // Add event listeners for the size buttons
    document.querySelectorAll('.size-button').forEach((button) => {
      button.addEventListener('click', function () {
        const selectedSizeName = this.dataset.sizeName; // Get the size name from the button dataset
        const selectedBasePrice = this.dataset.basePrice; // Get the base price from the button dataset
        console.log('button elements', this);
        console.log('selectedBasePrice', selectedBasePrice);

        // Store the selected size in a global variable
        /*selectedSize = {
          name: selectedSizeName,
          basePrice: selectedBasePrice,
        };*/

        // Close the modal
        sizeModal.style.display = 'none';

        // Resolve the Promise with the selected size
        resolve(selectedSize);
      });
    });
  });
}

async function showSummaryModal() {
  return new Promise((resolve) => {
    // Display selected size and base price
    document.getElementById('selectedSizeDisplay').textContent = selectedSize.size;
    document.getElementById('basePriceDisplay').textContent = selectedSize.basePrice.toFixed(2);

    // Calculate extra colors cost
    extraColors = Math.max(0, uniqueColorCountGlobal - 1); // Subtract 1 for the base text color
    extraColorsCost = extraColors * 50.00; // Example price for extra colors
    document.getElementById('extraColorsDisplay').textContent = extraColors;
    document.getElementById('extraColorsCostDisplay').textContent = extraColorsCost.toFixed(2);

    // Calculate ornament cost
    ornamentCount = ornamentsGroup.children.length;
    console.log('ornamentsGroup', ornamentsGroup);
    ornamentCost = ornamentCount * 50.00; // Example price for each ornament
    document.getElementById('ornamentCountDisplay').textContent = ornamentCount;
    document.getElementById('ornamentCostDisplay').textContent = ornamentCost.toFixed(2);

    // Calculate subtotal
    subtotal = parseFloat(selectedSize.basePrice) + extraColorsCost + ornamentCost;
    document.getElementById('subtotalDisplay').textContent = subtotal.toFixed(2);

    // Show the modal
    document.getElementById('summaryModal').style.display = 'flex';

    // Handle click on "Continuar" button
    document.getElementById('continueButton').onclick = function () {
      document.getElementById('summaryModal').style.display = 'none';
      resolve(true); // Proceed with the rest of the addToCart function
    };

    // Handle click on "Volver" button
    document.getElementById('backButton').onclick = function () {
      document.getElementById('summaryModal').style.display = 'none';
      resolve(false); // Stop the addToCart function
    };
  });
}

// Function to show the Orbit Controls Modal
function showOrbitControlsModal() {
  // Reset to the first instruction
  currentInstructionIndex = 0;
  updateOrbitControlsModal(); // Update modal content
  document.getElementById('orbitControlsModal').style.display = 'flex'; // Show modal
}

// Function to update modal with the current instruction
function updateOrbitControlsModal() {
  const instruction = instructions[currentInstructionIndex];
  document.getElementById('orbitControlsGif').src = instruction.gifUrl;
  document.getElementById('orbitControlsText').textContent = instruction.text;
  document.getElementById('orbitControlsButton').textContent = instruction.buttonText;
}

// Function to detect if the device is an Apple device (iPhone, iPad, or iPod)
function isAppleDevice() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

function isIPad() {
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}
